// This client was automatically generated by Segment Typewriter. ** Do Not Edit **
// To update this file, run:
//   npx typewriter

/**
 * User installed application
 */
export interface ApplicationInstalled {
    /**
     * Current application build
     */
    build?: string;
    /**
     * Current application version
     */
    version?: string;
    [property: string]: any;
}

/**
 * User opened application
 */
export interface ApplicationOpened {
    /**
     * Current application build
     */
    build?:                 string;
    from_background?:       boolean;
    referring_application?: string;
    /**
     * Referring application url
     */
    url?: string;
    /**
     * Current application version
     */
    version?: string;
    [property: string]: any;
}

/**
 * User updated application
 */
export interface ApplicationUpdated {
    /**
     * Current application build
     */
    build?: string;
    /**
     * Previous application build
     */
    previous_build?: string;
    /**
     * Previous application version
     */
    previous_version?: string;
    /**
     * Current application version
     */
    version?: string;
    [property: string]: any;
}

export interface CancelClick {
    plan?:     any;
    topic?:    any;
    trialing?: any;
    [property: string]: any;
}

export interface CancelRating {
    plan?:     any;
    stars?:    any;
    trialing?: any;
    [property: string]: any;
}

export interface CancelReason {
    cancel_option?: any;
    feeback?:       any;
    plan?:          any;
    topic?:         any;
    trialing?:      any;
    [property: string]: any;
}

/**
 * User initiated casting from mobile app
 */
export interface CastClass {
    "categories "?:  string;
    class_id?:       number;
    class_name?:     string;
    classId?:        number;
    content_locked?: boolean;
    instructor?:     string;
    level?:          string;
    method?:         string;
    program_slug?:   string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * The streaming method the class is being viewed
     */
    stream_method?: string;
    /**
     * Class style
     */
    style?: string;
    time?:  string;
    title?: string;
    type?:  string;
    [property: string]: any;
}

/**
 * User taps “Try Free & Subscribe”
 */
export interface CheckoutSelectElement {
    /**
     * ex. "Try Free & Subscribe"
     */
    element_copy?: string;
    /**
     * ex. "Annual Plan Button"
     */
    element_name?: string;
    /**
     * ex. "Button"
     */
    element_type?: string;
    /**
     * ex. "Checkout - Main"
     */
    location?: string;
    /**
     * ex. "onboarding"
     */
    module?: string;
    [property: string]: any;
}

/**
 * User clicked on learn more in subscription dialog
 */
export interface CheckoutSelectReferralsLearnMore {
    element_copy: string;
    element_type: string;
    location:     string;
    module:       string;
    [property: string]: any;
}

/**
 * User views new checkout page
 */
export interface CheckoutViewCheckout {
    /**
     * Google Click Identifier
     */
    gclid?: string;
    /**
     * location/screen that checkout page was viewed
     */
    location?: string;
    /**
     * ex. "onboarding, premium tab"
     */
    module?: string;
    [property: string]: any;
}

/**
 * User views Monthly Modal (ie they tapped “I’d rather pay monthly”)
 */
export interface CheckoutViewModal {
    element_copy?: string;
    /**
     * "[Plan] Option Button"
     */
    element_name?: string;
    /**
     * ex. "Button"
     */
    element_type?: string;
    /**
     * ex. "Checkout - Main"
     */
    location?: string;
    /**
     * ex. "onboarding"
     */
    module?: string;
    [property: string]: any;
}

export interface ClassCompleteClass {
    ""?: { [key: string]: any };
    /**
     * Can be studio or family
     */
    account_mode?: AccountMode;
    categories?:   string[];
    /**
     * Class identifier
     */
    "class_id "?:    number;
    content_locked?: boolean;
    /**
     * Class instructor
     */
    instructor?: string;
    /**
     * Class difficulty level
     */
    level?: string;
    /**
     * Identify if the class is Saved in user preferences
     */
    saved?: boolean;
    /**
     * The streaming method the class is being viewed
     */
    stream_method?: string;
    /**
     * Class style
     */
    style?: string;
    /**
     * Class title
     */
    title?: string;
    /**
     * Class type
     */
    type?: string;
    [property: string]: any;
}

/**
 * Can be studio or family
 *
 * Can studio or family
 */
export enum AccountMode {
    Family = "family",
    Studio = "studio",
}

export interface ClassContinueClass {
    /**
     * Can be studio or family
     */
    account_mode?:   AccountMode;
    categories?:     string[];
    "categories "?:  string;
    class_id?:       any;
    content_locked?: boolean;
    daypart?:        any;
    demo?:           any;
    instructor?:     any;
    level?:          any;
    program_slug?:   string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * The streaming method the class is being viewed
     */
    stream_method?: string;
    /**
     * Class style
     */
    style?: string;
    title?: any;
    type?:  any;
    [property: string]: any;
}

/**
 * User initiated class download in mobile app
 */
export interface ClassDownloadClass {
    /**
     * A list of category slugs associated with the class
     */
    "categories "?: string[];
    /**
     * The ID of the class
     */
    "class_id ": number;
    /**
     * The full name of the instructor of the class
     */
    instructor?: string;
    /**
     * The difficulty level of the class
     */
    level?: string;
    /**
     * The slug of the associated program
     */
    program_slug?: string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * Class style
     */
    style?: string;
    /**
     * The title of the class
     */
    title?: string;
    /**
     * The type of the class
     */
    type?: string;
    [property: string]: any;
}

export interface ClassDownloadComplete {
    class_id:    number;
    instructor?: string;
    level?:      string;
    /**
     * Class style
     */
    style?: string;
    title?: string;
    type?:  string;
    [property: string]: any;
}

/**
 * User ended class
 */
export interface ClassEndClass {
    categories?: string[];
    /**
     * Class identifier
     */
    class_id:        number;
    content_locked?: boolean;
    daypart?:        any;
    demo?:           any;
    /**
     * Class instructor
     */
    instructor?: string;
    /**
     * Class level
     */
    level?: string;
    /**
     * Method user utilized to exit the class player
     */
    method?: string;
    /**
     * Amount of total class taken; reviewing a section does not contribute to increased
     * percent_complete
     */
    percent_completed?: number;
    /**
     * Relative position on video Progress Bar
     */
    percent_progress?: number;
    /**
     * Programs associated with class
     */
    program_slug?: string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * The streaming method the class is being viewed
     */
    stream_method?: string;
    /**
     * Class style
     */
    style?: string;
    /**
     * Class Title
     */
    title?: string;
    type?:  any;
    [property: string]: any;
}

export interface ClassOpenClass {
    categories?:   string;
    "class_id "?:  any;
    classId?:      any;
    "classId "?:   any;
    instructor?:   any;
    level?:        any;
    program_slug?: string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * Class style
     */
    style?: string;
    title?: any;
    type?:  any;
    [property: string]: any;
}

export interface ClassPause {
    casting?:     string;
    "class_id "?: any;
    classId?:     any;
    "classId "?:  any;
    instructor?:  any;
    level?:       any;
    /**
     * Class style
     */
    style?: string;
    time?:  any;
    title?: any;
    type?:  any;
    view?:  any;
    [property: string]: any;
}

export interface ClassPauseClass {
    "classId "?: any;
    instructor?: any;
    level?:      any;
    /**
     * Class style
     */
    style?: string;
    title?: any;
    type?:  any;
    [property: string]: any;
}

export interface ClassPlay {
    casting?:     string;
    "class_id "?: any;
    classId?:     any;
    "classId "?:  any;
    instructor?:  any;
    level?:       any;
    /**
     * Class style
     */
    style?: string;
    time?:  any;
    title?: any;
    type?:  any;
    view?:  any;
    [property: string]: any;
}

export interface ClassPlayerBuffering {
    categories?:                        Categories;
    class_id?:                          any;
    completedAllOtherClassesInProgram?: boolean;
    credits?:                           string;
    current_time_in_seconds?:           any;
    date_allowed?:                      string;
    duration?:                          string;
    duration_group?:                    string;
    duration_in_seconds?:               number;
    event?:                             Event;
    explicit?:                          boolean;
    free?:                              boolean;
    id?:                                number;
    instructor?:                        any;
    instructor_name?:                   string;
    instructor_slug?:                   string;
    isFree?:                            boolean;
    isLastClass?:                       boolean;
    isPurchased?:                       boolean;
    keywords?:                          string[];
    lastModifiedDate?:                  string;
    level?:                             any;
    model_name?:                        string;
    playlists?:                         Playlists;
    preview_url?:                       string;
    programs?:                          string[];
    publish_date?:                      string;
    schedules?:                         Schedules;
    slug?:                              string;
    songs?:                             Song[];
    /**
     * Class style
     */
    style?:      string;
    style_slug?: string;
    /**
     * List of associated styles
     */
    styles?:           string[];
    styles_query?:     StylesQuery;
    techniques?:       string[];
    techniques_query?: TechniquesQuery;
    techniques_slugs?: string[];
    thumbnail?:        string;
    title?:            any;
    type?:             any;
    url?:              string;
    video_url?:        any;
    [property: string]: any;
}

export interface Categories {
    "dance-workout"?:        boolean;
    dancehall?:              boolean;
    heels?:                  boolean;
    house?:                  boolean;
    "popular-choreography"?: boolean;
    "tips-and-lectures"?:    boolean;
    [property: string]: any;
}

export interface Event {
    isTrusted?: boolean;
    [property: string]: any;
}

export interface Playlists {
    "7-days-of-steezy-0"?: string;
    "7-days-of-steezy-1"?: string;
    "7-days-of-steezy-2"?: string;
    "7-days-of-steezy-3"?: string;
    "7-days-of-steezy-4"?: string;
    "7-days-of-steezy-5"?: string;
    "7-days-of-steezy-6"?: string;
    [property: string]: any;
}

export interface Schedules {
    "7-days-of-steezy"?: string;
    [property: string]: any;
}

export interface Song {
    apple_music?: string;
    artist?:      string;
    explicit?:    boolean;
    spotify?:     string;
    title?:       string;
    youtube?:     string;
    [property: string]: any;
}

export interface StylesQuery {
    "b-boying"?:             boolean;
    "dance-workout"?:        boolean;
    dancehall?:              boolean;
    heels?:                  boolean;
    "hip-hop"?:              boolean;
    house?:                  boolean;
    "jazz-funk"?:            boolean;
    kpop?:                   boolean;
    krump?:                  boolean;
    "lite-feet"?:            boolean;
    locking?:                boolean;
    "open-style"?:           boolean;
    popping?:                boolean;
    "popular-dances"?:       boolean;
    "tiktok-dances"?:        boolean;
    "urban-dance"?:          boolean;
    "warmup-and-stretches"?: boolean;
    whacking?:               boolean;
    workout?:                boolean;
    [property: string]: any;
}

export interface TechniquesQuery {
    control?:    boolean;
    floorwork?:  boolean;
    footwork?:   boolean;
    foundation?: boolean;
    groove?:     boolean;
    isolation?:  boolean;
    speed?:      boolean;
    strength?:   boolean;
    texture?:    boolean;
    undefined?:  boolean;
    [property: string]: any;
}

/**
 * User returned to take class again
 */
export interface ClassReviewClass {
    categories?:            string[];
    "categories "?:         string;
    class_id?:              any;
    "class_id "?:           any;
    classId?:               number;
    content_locked?:        boolean;
    daypart?:               any;
    demo?:                  any;
    instructor?:            string;
    level?:                 string;
    location?:              string;
    program_block_index?:   number | null;
    program_block_title?:   string;
    program_section_index?: number | null;
    program_section_title?: string;
    program_slug?:          string;
    /**
     * Title of program being taken
     */
    program_title?: string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * The streaming method the class is being viewed
     */
    stream_method?: string;
    /**
     * Class style
     */
    style?: string;
    title?: string;
    type?:  string;
    [property: string]: any;
}

export interface ClassReviewSection {
    casting?:     string;
    "class_id "?: any;
    classId?:     any;
    "classId "?:  any;
    instructor?:  any;
    level?:       any;
    /**
     * Class style
     */
    style?:   string;
    time?:    any;
    "time "?: any;
    title?:   any;
    type?:    any;
    view?:    any;
    "view "?: any;
    [property: string]: any;
}

export interface ClassSkip {
    casting?:      string;
    "class_id "?:  any;
    classId?:      any;
    direction?:    any;
    "direction "?: any;
    instructor?:   any;
    level?:        any;
    /**
     * Class style
     */
    style?:   string;
    time?:    any;
    "time "?: any;
    title?:   any;
    type?:    any;
    view?:    any;
    "view "?: any;
    [property: string]: any;
}

export interface ClassSkipSection {
    casting?:      boolean;
    "class_id "?:  any;
    classId?:      number;
    "classId "?:   any;
    direction?:    string;
    "direction "?: any;
    instructor?:   any;
    level?:        any;
    /**
     * Class style
     */
    style?:   string;
    time?:    string;
    "time "?: any;
    title?:   any;
    type?:    any;
    view?:    string;
    "view "?: any;
    [property: string]: any;
}

export interface ClassSpeed {
    casting?: string;
    level?:   any;
    speed?:   any;
    /**
     * Class style
     */
    style?: string;
    title?: any;
    type?:  any;
    [property: string]: any;
}

/**
 * User started Class for the first time. Event is designed to fire the first time a user
 * starts a Class in each app
 */
export interface ClassStartClass {
    /**
     * Can be studio or family
     */
    account_mode?:   AccountMode;
    categories?:     string[];
    "categories "?:  string;
    class_id?:       any;
    classId?:        any;
    content_locked?: boolean;
    daypart?:        any;
    demo?:           any;
    instructor?:     any;
    level?:          any;
    location?:       string;
    /**
     * The ID of the playlist that the class is starting from.
     */
    playlist_id?:           string;
    program_block_index?:   number;
    program_block_title?:   string;
    program_section_index?: number;
    program_section_title?: string;
    program_slug?:          string;
    program_title?:         string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * The streaming method the class is being viewed
     */
    stream_method?: string;
    /**
     * Class style
     */
    style?: string;
    title?: any;
    type?:  any;
    [property: string]: any;
}

export interface ClassSwitchView {
    casting?: string;
    classId?: any;
    time?:    any;
    view?:    any;
    "view "?: any;
    [property: string]: any;
}

/**
 * Tracks the user's current state and progression while they are taking a class. The event
 * is triggered at an interval based on the value provided in the "interval" attribute
 */
export interface ClassTakingClass {
    /**
     * True if the user's webcam is enabled
     */
    camera?: boolean;
    /**
     * A list of categories associated with the class
     */
    categories?: string[];
    /**
     * The ID of the class
     */
    class_id?:       number;
    content_locked?: boolean;
    /**
     * When the user is watching the class
     */
    daypart?: string;
    /**
     * The instructor of the class
     */
    instructor?: string;
    /**
     * How often the event is being triggered in seconds
     */
    interval?: number;
    /**
     * The level of the class
     */
    level?: any;
    /**
     * True if the user is looping the class
     */
    looping?: boolean;
    /**
     * True if the user is mirroring the class
     */
    mirrored?: boolean;
    /**
     * What percentage of the class they are currently viewing. Current timestamp / Total
     * duration
     */
    percent_progress?: number;
    /**
     * The associated program slug
     */
    program_slug?: string;
    /**
     * Set to true if user has saved the class
     */
    saved?:                  boolean;
    session_minute_reached?: any;
    /**
     * The streaming method the class is being viewed
     */
    stream_method?: string;
    /**
     * The style of the class
     */
    style?: string;
    /**
     * The title of the class
     */
    title?: string;
    /**
     * The type of the class
     */
    type?: string;
    /**
     * Whether the class is being viewed from the front or back
     */
    view?: View;
    [property: string]: any;
}

/**
 * Whether the class is being viewed from the front or back
 */
export enum View {
    Back = "back",
    Front = "front",
}

export interface ClassToggleMirror {
    classId?: number;
    mirror?:  string;
    time?:    string;
    [property: string]: any;
}

export interface ClickExternalLink {
    service?: any;
    url?:     any;
    [property: string]: any;
}

export interface ClickLink {
    destination?:  any;
    in_component?: any;
    path?:         any;
    [property: string]: any;
}

export interface ClickShare {
    component?: any;
    path?:      any;
    platform?:  any;
    [property: string]: any;
}

export interface CommunityContentFlag {
    challenge_active?: boolean;
    challenge_id?:     string;
    content_id?:       string;
    content_type?:     CommunityContentFlagContentType;
    content_user_id?:  string;
    element_name?:     string;
    location?:         string;
    module?:           string;
    reason?:           string;
    [property: string]: any;
}

export enum CommunityContentFlagContentType {
    Comment = "comment",
    UserVideo = "user_video",
}

/**
 * When a user selects a UI element on Steezy's Community feature
 */
export interface CommunitySelectElement {
    /**
     * The copy of the element
     */
    element_copy?: string;
    /**
     * The proper name of the element
     */
    element_name?: string;
    /**
     * The type of element i.e. "button"
     */
    element_type?: string;
    /**
     * The domain within our app this event took place
     */
    location?: string;
    /**
     * A feature within a domain this event took place
     */
    module?: string;
    [property: string]: any;
}

export interface CommunitySubmitComment {
    challenge_active?: boolean;
    challenge_id?:     string;
    comment_length?:   number;
    content_id?:       string;
    content_type?:     string;
    content_user_id?:  string;
    element_name?:     string;
    element_type?:     string;
    location?:         string;
    module?:           string;
    [property: string]: any;
}

/**
 * Activity that occurs on a user video that includes comments, likes, and replies.
 */
export interface CommunityVideoActivity {
    /**
     * The ID of the comment.
     */
    comment_id?: string;
    /**
     * The UID of the user that the action is going to.
     */
    to_user_id: string;
    /**
     * The type of activity that occurred on the video.
     */
    type: Type;
    /**
     * The ID of the video.
     */
    video_id: string;
    [property: string]: any;
}

/**
 * The type of activity that occurred on the video.
 */
export enum Type {
    Comment = "comment",
    Like = "like",
    Reply = "reply",
    Unlike = "unlike",
    View = "view",
}

/**
 * Event should fire when the Community Rules modal is loaded for the user.
 */
export interface CommunityViewCommunityGuidelines {
    location?: string;
    module?:   string;
    [property: string]: any;
}

export interface ContentFilterClasses {
    categories?:                string;
    class_duration_in_seconds?: string;
    class_lengths?:             string[];
    hideExplicit?:              string[];
    instructor_name?:           string;
    instructors?:               string[];
    levels?:                    string[];
    mood?:                      any[];
    path?:                      any;
    selectedInstructor?:        string[];
    showDownloadOnly?:          boolean;
    sort?:                      string[];
    /**
     * Class style
     */
    style?: string;
    /**
     * List of associated styles
     */
    styles?: string[];
    types?:  string[];
    [property: string]: any;
}

export interface ContentFilterPrograms {
    categories?: string[];
    levels?:     string[];
    path?:       any;
    sort?:       any;
    /**
     * List of associated class styles
     */
    styles?: string[];
    [property: string]: any;
}

/**
 * User engages with class preview video
 */
export interface ContentPreviewClass {
    categories?:             string[];
    class_id?:               number;
    content_locked?:         boolean;
    duration?:               any;
    instructor?:             any;
    is_preview_video_muted?: boolean;
    level?:                  string[];
    location?:               string;
    path?:                   any;
    program_slug?:           string;
    program_style?:          any;
    program_title?:          any;
    /**
     * Set to true if user has saved the class
     */
    saved?:         boolean;
    selected_from?: string;
    /**
     * Class style
     */
    style?: string;
    title?: any;
    type?:  any;
    [property: string]: any;
}

/**
 * User engages with program preview video
 */
export interface ContentPreviewProgram {
    categories?:     string[];
    classId?:        number;
    content_locked?: boolean;
    duration?:       number;
    instructor?:     string;
    level?:          string;
    path?:           any;
    program_slug?:   string;
    /**
     * Set to true if user has saved the class
     */
    saved?:         boolean;
    selected_from?: string;
    /**
     * Class style
     */
    style?: string;
    title?: string;
    type?:  string;
    [property: string]: any;
}

export interface ContentSelectCategory {
    categories?: string[];
    event_time?: string;
    module?:     string;
    path?:       string;
    [property: string]: any;
}

/**
 * User selects Class from UI
 */
export interface ContentSelectClass {
    /**
     * Can be studio or family
     */
    account_mode?:              AccountMode;
    categories?:                string[];
    "categories "?:             string;
    class_id?:                  number;
    class_list_index_location?: number;
    class_navigation_count?:    number;
    class_title?:               any;
    content_locked?:            boolean;
    event_time?:                string;
    location?:                  string;
    path?:                      any;
    /**
     * The ID of the playlist that the class is selected from.
     */
    playlist_id?:       string;
    previous_class_id?: any;
    program_level?:     string[];
    program_slug?:      string;
    program_style?:     any;
    program_title?:     any;
    selected_from?:     any;
    title?:             any;
    [property: string]: any;
}

export interface ContentSelectElement {
    class_id?:        string;
    class_title?:     string;
    element_name?:    string;
    element_type?:    string;
    location?:        string;
    module?:          string;
    playlist_id?:     string;
    taken_list_date?: string;
    [property: string]: any;
}

/**
 * User selects a playlist to view.
 */
export interface ContentSelectPlaylist {
    /**
     * The general location where the playlist was selected.
     */
    location: string;
    /**
     * The page where the playlist was selected.
     */
    module: string;
    /**
     * The ID of the playlist.
     */
    playlist_id: string;
    /**
     * The name of the playlist.
     */
    playlist_name: string;
    /**
     * The user ID of the owner of the playlist or 'steezy'.
     */
    playlist_user_id: string;
    [property: string]: any;
}

/**
 * User selects Program from UI
 */
export interface ContentSelectProgram {
    /**
     * Array of categories that the selected program belongs to
     */
    categories?: string[];
    /**
     * Difficulty level
     */
    level?: string;
    /**
     * location from which program is selected from
     */
    location?: string;
    /**
     * module from which program is selected from
     */
    module?: string;
    /**
     * Designated program slug
     */
    program_slug: string;
    /**
     * Title of program
     */
    program_title: string;
    /**
     * UI component in which this event fired
     */
    selected_from?: string;
    /**
     * Class style
     */
    style?: string;
    [property: string]: any;
}

/**
 * User opting to share the content they're viewing.
 */
export interface ContentShareContent {
    /**
     * The ID of the content.
     */
    content_id: string;
    /**
     * The title or the name of the content
     */
    content_title: string;
    /**
     * The type of the content.
     */
    content_type: string;
    /**
     * The general location where the content is being shared from.
     */
    location: string;
    /**
     * The page where the content is being shared from.
     */
    module: string;
    [property: string]: any;
}

/**
 * User saved or unsaved class
 */
export interface ContentToggleSaveClass {
    categories?:   string[];
    "class_id "?:  number;
    component?:    any;
    instructor?:   string;
    level?:        any;
    program_slug?: string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * Class style
     */
    style?: string;
    title?: any;
    type?:  any;
    [property: string]: any;
}

/**
 * User saving or unsaving the playlist
 */
export interface ContentToggleSavePlaylist {
    /**
     * The general location where the playlist was saved or unsaved.
     */
    location: string;
    /**
     * The page where the playlist was saved or unsaved.
     */
    module: string;
    /**
     * The ID of the playlist.
     */
    playlist_id: string;
    /**
     * The name of the playlist.
     */
    playlist_name: string;
    /**
     * The user ID of the owner of the playlist or 'steezy'.
     */
    playlist_user_id: string;
    [property: string]: any;
}

/**
 * User saved or unsaved program
 */
export interface ContentToggleSaveProgram {
    /**
     * List of categories this program belongs to
     */
    categories?: string[];
    /**
     * UI component in which the program was saved
     */
    component?: any;
    /**
     * Slug of the program
     */
    program_slug: string;
    /**
     * Title of the program
     */
    program_title?: string;
    /**
     * Set to true if user has saved the class
     */
    saved?: boolean;
    /**
     * Style this program belongs to
     */
    style?: string;
    [property: string]: any;
}

/**
 * When a user has selected a specific element on the UI
 */
export interface ElementSelected {
    /**
     * Element name i.e. ProgramDetailsButton
     */
    element_name: string;
    /**
     * Element type i.e. button
     */
    element_type: string;
    /**
     * The feature the element is related to i.e. ForYou
     */
    feature?:  string;
    location?: string;
    /**
     * The module the element is encapsulated within
     */
    module?: string;
    /**
     * Name of the UI screen the user is on i.e. Dashboard
     */
    screen_name?: string;
    [property: string]: any;
}

/**
 * When a user is rendered a specific view on the UI
 */
export interface ElementViewed {
    /**
     * Element name
     */
    element_name: string;
    /**
     * Element type
     */
    element_type: string;
    /**
     * The feature the view is related to
     */
    feature?: string;
    /**
     * The module the view is related to
     */
    module?: string;
    /**
     * The screen the element was rendered on
     */
    screen_name: string;
    [property: string]: any;
}

/**
 * To track errors that occur in the app
 */
export interface Error {
    /**
     * The screen or route the error occurred on
     */
    location?: string;
    /**
     * The error message
     */
    message: string;
    /**
     * The platform the error occurred on
     */
    platform: string;
    [property: string]: any;
}

/**
 * fires when user interacts with an interactive FUX item
 */
export interface FUXSelectElement {
    /**
     * place on list that class appears for user (0 based index)
     */
    class_card_index?: number;
    /**
     * id of class
     */
    class_id?: number;
    /**
     * title of class
     */
    class_title?: string;
    /**
     * copy on the element
     */
    element_copy?: string;
    /**
     * name of element
     */
    element_name: string;
    /**
     * type of element
     */
    element_type: string;
    /**
     * location/screen that the element was interacted with
     */
    location: string;
    /**
     * ex: "premium tab"
     */
    module: string;
    [property: string]: any;
}

/**
 * user views Plan Details screen on Premium tab
 */
export interface FUXViewPlanDetails {
    /**
     * ex: "Premium Tab"
     */
    module?: string;
    /**
     * type of plan user is on (ex: "Lite")
     */
    plan_type?: string;
    [property: string]: any;
}

/**
 * fires user sees Premium tab main page
 */
export interface FUXViewPremiumTab {
    /**
     * the module this event is fired from
     */
    module: string;
    [property: string]: any;
}

export interface FUXViewSubscriptionModal {
    /**
     * categories of the locked class the modal is triggered from
     */
    categories?: string[];
    /**
     * ID of the locked class the modal is triggered from
     */
    class_id?:    number;
    content_type: FUXViewSubscriptionModalContentType;
    /**
     * name of locked feature that displayed the modal
     */
    feature_name?: string;
    /**
     * instructor of the locked class the modal is triggered from
     */
    instructor?: string;
    /**
     * Name of element that caused the modal to be displayed
     */
    method: string;
    /**
     * Where the modal was triggered from
     */
    module: string;
    /**
     * slug of program the modal is triggered from
     */
    program_slug?: string;
    /**
     * title of program the modal is triggered from
     */
    program_title?: string;
    /**
     * style of the locked class the modal is triggered from
     */
    style?: string;
    /**
     * categories of the locked class the modal is triggered from
     */
    title?: string;
    [property: string]: any;
}

export enum FUXViewSubscriptionModalContentType {
    Class = "class",
    Feature = "feature",
    Program = "program",
}

export interface FUXViewTryFreeModal {
    /**
     * ex. "FUX Program Modal"
     */
    element_name?: string;
    /**
     * ex. "For You"
     */
    location?: string;
    /**
     * ex. "For You"
     */
    module?: string;
    [property: string]: any;
}

/**
 * user successfully enters Family mode after selecting it from the mode selection screen
 */
export interface FamilyEnterFamilyMode {
    location?: string;
    module?:   string;
    [property: string]: any;
}

/**
 * user successfully enters Studio mode after selecting it from the mode selection screeen
 * and entering the correct PIN
 */
export interface FamilyEnterStudioMode {
    location?: string;
    module?:   string;
    [property: string]: any;
}

/**
 * user does an action on the pin flow page
 */
export interface FamilyManageFamilyMode {
    action?:   string;
    location?: string;
    module?:   string;
    [property: string]: any;
}

export interface FirstLaunchSelectElement {
    element_copy?: string;
    element_name?: string;
    element_type?: string;
    location?:     string;
    module?:       string;
    [property: string]: any;
}

export interface FirstLaunchViewModal {
    /**
     * copy on the modal
     */
    element_copy?: string;
    /**
     * name of modal
     */
    element_name?: string;
    /**
     * most likely this is a modal
     */
    element_type?: string;
    /**
     * location modal is inflated in
     */
    location?: string;
    /**
     * module modal is inflated in
     */
    module?: string;
    /**
     * slug of program if there's a program
     */
    program_slug?: string;
    [property: string]: any;
}

/**
 * fires when user interacts with content in the carousel on home
 */
export interface HomeSelectContent {
    /**
     * carousel title in snake_case
     */
    container: HomeSelectContentContainer;
    /**
     * id of content being clicked on; class_id, program slug, etc.
     */
    content_id: string;
    /**
     * title of content
     */
    content_name: string;
    /**
     * type of content being accessed; class, program, etc.
     */
    content_type: HomeSelectContentContentType;
    /**
     * type of element
     */
    element_type: string;
    /**
     * is the content a featured type
     */
    featured: boolean;
    /**
     * location/screen that the element was interacted with
     */
    location: string;
    /**
     * ex: "premium tab"
     */
    module?: string;
    [property: string]: any;
}

/**
 * carousel title in snake_case
 */
export enum HomeSelectContentContainer {
    BecauseYouLiked = "because_you_liked",
    ContinueDancing = "continue_dancing",
    DanceWorkouts = "dance_workouts",
    FeaturedContent = "featured_content",
    Moves = "moves",
    MovesAndTechniques = "moves_and_techniques",
    Programs = "programs",
    RecommendedWeeklyPlaylist = "recommended_weekly_playlist",
    SavedClasses = "saved_classes",
    Schedule = "schedule",
    TechniqueAndFundamentals = "technique_and_fundamentals",
    TodaysClasses = "todays_classes",
    TrendingClassesLevel = "trending_classes_level",
    WarmupsAndStretches = "warmups_and_stretches",
    WarmupsStretchesAndFundamentals = "warmups_stretches_and_fundamentals",
    Workouts = "workouts",
}

/**
 * type of content being accessed; class, program, etc.
 */
export enum HomeSelectContentContentType {
    Class = "class",
    Program = "program",
}

/**
 * fires when user clicks "Results" button after applying filters
 */
export interface LibraryFilterContent {
    /**
     * Can be studio or family
     */
    account_mode?: AccountMode;
    /**
     * array of filters applied
     */
    filters_applied?: string[];
    /**
     * location content was filtered on
     */
    location?: string;
    /**
     * ex: "library_classes", "library_programs"
     */
    module?: string;
    [property: string]: any;
}

/**
 * fires when user selects content from library page
 */
export interface LibrarySelectContent {
    /**
     * Can studio or family
     */
    account_mode?: AccountMode;
    /**
     * title of the section the content is in (must be in snake_case)
     */
    container?: LibrarySelectContentContainer;
    /**
     * id/slug of content selected
     */
    content_id?: string;
    /**
     * name of content selected
     */
    content_name?: string;
    /**
     * type of content selected
     */
    content_type?: LibrarySelectContentContentType;
    /**
     * type of element
     */
    element_type?: string;
    /**
     * indicates if featured content
     */
    featured?: boolean;
    /**
     * array of filters applied
     */
    filters_applied?: string[];
    /**
     * location/screen content was selected in
     */
    location?: string;
    /**
     * ex: "library_classes", "library_programs"
     */
    module?: string;
    [property: string]: any;
}

/**
 * title of the section the content is in (must be in snake_case)
 */
export enum LibrarySelectContentContainer {
    Categories = "categories",
    Classes = "classes",
    FeaturedClass = "featured_class",
    Instructors = "instructors",
    Programs = "programs",
    RecentClasses = "recent_classes",
}

/**
 * type of content selected
 */
export enum LibrarySelectContentContentType {
    Category = "category",
    Class = "class",
    Instructor = "instructor",
    Program = "program",
}

/**
 * fires when user interacts with an interactive item in Library
 */
export interface LibrarySelectElement {
    /**
     * Can be studio or family
     */
    account_mode?: AccountMode;
    /**
     * name of element
     */
    element_name?: string;
    /**
     * type of element
     */
    element_type?: string;
    /**
     * location/screen that the element was interacted with
     */
    location?: string;
    /**
     * ex: "library_classes", "library_programs"
     */
    module?: string;
    [property: string]: any;
}

/**
 * fires when user view screen in library
 */
export interface LibraryViewScreen {
    /**
     * Can be studio or family
     */
    account_mode?: AccountMode;
    /**
     * location screen was viewed in
     */
    location?: string;
    /**
     * ex: "library_classes", "library_programs"
     */
    module?: string;
    /**
     * name of screen viewed
     */
    screen_name?: string;
    [property: string]: any;
}

/**
 * This is an event to fire when a component has loaded or mounted.
 */
export interface LoadedComponent {
    /**
     * Name of the component
     */
    component?: string;
    [property: string]: any;
}

export interface ManageSubscriptionSelectElement {
    element_name?: string;
    element_type?: string;
    location?:     string;
    module?:       string;
    [property: string]: any;
}

export interface ManageSubscriptionViewModal {
    element_name?: string;
    element_type?: string;
    location?:     string;
    module?:       string;
    [property: string]: any;
}

export interface ManageSubscriptionViewOffer {
    element_name?: string;
    element_type?: string;
    location?:     string;
    module?:       string;
    [property: string]: any;
}

export interface NotificationPermissions {
    element_copy?:         string;
    element_name:          string;
    element_type:          string;
    location:              string;
    module:                string;
    notifications_allowed: boolean;
    [property: string]: any;
}

export interface OnboardingAccountInfoError {
    code?:     any;
    email?:    any;
    Message?:  any;
    provider?: any;
    [property: string]: any;
}

/**
 * Onboarding Funnel: user creates an account
 */
export interface OnboardingCompleteAccountInfo {
    auth_provider?:         any;
    days_since_first_seen?: any;
    email?:                 any;
    first_name?:            any;
    /**
     * Google Click Identifier
     */
    gclid?:     string;
    last_name?: any;
    /**
     * Is Ad Tracking Enabled
     */
    onboarding_ad_enabled?: boolean;
    /**
     * Advertising Identifier
     */
    onboarding_ad_id?: string;
    path?:             any;
    product_id?:       any;
    products?:         OnboardingCompleteAccountInfoProduct[];
    variant?:          any;
    [property: string]: any;
}

export interface OnboardingCompleteAccountInfoProduct {
    price?:      number;
    product_id?: string;
    quantity?:   number;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects how they heard about STEEZY
 */
export interface OnboardingHDYHAU {
    /**
     * List of survey responses that user heard about STEEZY from
     */
    survey_response?: string[];
    [property: string]: any;
}

export interface OnboardingPaymentError {
    error?:          any;
    payment_method?: any;
    [property: string]: any;
}

export interface OnboardingRegisterScreen {
    class_id?:      any;
    path?:          any;
    previous_path?: any;
    product_id?:    any;
    products?:      any;
    program_id?:    any;
    utm_campaign?:  string[];
    utm_content?:   string[];
    utm_id?:        string[];
    utm_medium?:    string[];
    utm_source?:    string[];
    utm_term?:      string[];
    variant?:       any;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects class category preferences
 */
export interface OnboardingSelectCategories {
    /**
     * web is sending this
     */
    categories?:       string[];
    categories_array?: string[];
    /**
     * ios and android are sending this
     */
    category_array?: string[];
    module?:         string;
    path?:           string;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects when they dance
 */
export interface OnboardingSelectDanceCadence {
    days_of_week?: string[];
    module?:       string;
    num_of_days?:  string;
    path?:         any;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects their dance energy preference
 */
export interface OnboardingSelectDanceEnergy {
    dance_energy?: string;
    module?:       string;
    path?:         any;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects how often they want to dance
 */
export interface OnboardingSelectDanceFrequency {
    dance_frequency?: string;
    module?:          string;
    path?:            any;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects their dance goals
 */
export interface OnboardingSelectDanceGoals {
    dance_goals?: string[];
    module?:      string;
    path?:        any;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects how often they want to dance
 */
export interface OnboardingSelectDanceHabit {
    habit?:  string;
    module?: string;
    path?:   any;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects where they prefer to dance
 */
export interface OnboardingSelectDanceLocations {
    dance_locations?: string[];
    module?:          string;
    path?:            any;
    [property: string]: any;
}

export interface OnboardingSelectDanceStyles {
    style_array?: string;
    [property: string]: any;
}

/**
 * user chooses an option in the “Select Your Dancer” question during the account creation
 * survey
 */
export interface OnboardingSelectDancer {
    dancer_array?: any[];
    location?:     string;
    module?:       string;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects class length preferences
 */
export interface OnboardingSelectDuration {
    Max?:    number;
    max?:    number;
    Min?:    number;
    min?:    number;
    module?: string;
    path?:   any;
    [property: string]: any;
}

/**
 * user selects a choice on the “Family Dance Goal” question during the account creation
 * survey
 */
export interface OnboardingSelectFamilyGoal {
    family_goal?: string;
    location?:    string;
    module?:      string;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects their self-identified dance skill level
 */
export interface OnboardingSelectLevel {
    dance_level?: string;
    module?:      string;
    path?:        any;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects reason for signing up
 */
export interface OnboardingSelectReason {
    module?: string;
    path?:   any;
    reason?: string;
    [property: string]: any;
}

/**
 * Onboarding survey: user selects their age group
 */
export interface OnboardingSelectUserAge {
    module?:   string;
    path?:     any;
    user_age?: string;
    [property: string]: any;
}

/**
 * Onboarding Funnel: user starts free trial (checkout)
 */
export interface OnboardingStartTrial {
    coupon?:             any;
    daypart?:            any;
    days_since_created?: any;
    /**
     * The value of the coupon code (either the plan_price * % off, or the flat discount amount).
     */
    discount?:         any;
    discount_amount?:  any;
    discount_percent?: any;
    /**
     * Google Click Identifier
     */
    gclid?: string;
    /**
     * Is ad tracking enabled
     */
    onboarding_ad_enabled?: boolean;
    /**
     * Advertising Identifier
     */
    onboarding_ad_id?:          string;
    order_id?:                  any;
    path?:                      any;
    payment_method?:            any;
    plan?:                      any;
    plan_price?:                any;
    plan_price_after_discount?: any;
    platform?:                  string;
    product_id?:                any;
    products?:                  OnboardingStartTrialProduct[];
    referred_by?:               any;
    referred_by_username?:      any;
    subscription_id?:           any;
    subscription_renewal_date?: Date;
    subscription_start_date?:   Date;
    trial_length?:              any;
    utm_campaign?:              string[];
    utm_content?:               string[];
    utm_id?:                    string[];
    utm_medium?:                string[];
    utm_source?:                string[];
    utm_term?:                  string[];
    variant?:                   any;
    [property: string]: any;
}

export interface OnboardingStartTrialProduct {
    price?:      number;
    product_id?: string;
    quantity?:   number;
    [property: string]: any;
}

export interface OnboardingVideo {
    duration?:   any;
    end_time?:   any;
    slug?:       any;
    start_time?: any;
    [property: string]: any;
}

/**
 * Fire this event whenever an order/transaction was successfully completed by the customer.
 */
export interface OrderCompleted {
    /**
     * The coupon code applied at checkout
     */
    coupon?: string;
    /**
     * The localized currency of the user
     */
    currency?: string;
    /**
     * User's order or transaction ID of the payment provider
     */
    order_id?: string;
    /**
     * Products in the order
     */
    products?: OrderCompletedProduct[];
    [property: string]: any;
}

export interface OrderCompletedProduct {
    /**
     * Name of the product being viewed
     */
    name?: string;
    /**
     * Price ($) of the product being viewed
     */
    price?: number;
    /**
     * Database id of the product being viewed
     */
    product_id?: string;
    /**
     * Quantity of a product
     */
    quantity?: number;
    /**
     * Sku of the product being viewed
     */
    sku?: string;
    [property: string]: any;
}

export interface PageViewed {
    anonymous?:     any;
    path?:          any;
    previous_path?: any;
    referrer?:      any;
    search?:        any;
    title?:         any;
    url?:           any;
    [property: string]: any;
}

/**
 * Web tracking initial load events of an HLS.js player. It intentionally tracks just the
 * first instance of each load event to measure initial timings, discarding subsequent
 * occurences.
 */
export interface PlayerLoad {
    /**
     * Class ID
     */
    class_id: number;
    /**
     * True if user is in a party
     */
    in_a_party?:          boolean;
    initial_hls_quality?: string;
    /**
     * What phase of the load event is occurring. Can be one of six values.
     */
    load_event_name:            LoadEventName;
    manifest_experiment_group?: string;
    /**
     * Hours in playback time
     */
    "playback_time.hour"?: number;
    /**
     * Minutes in playback time
     */
    "playback_time.minute"?: number;
    /**
     * Seconds in playback time
     */
    "playback_time.second"?: number;
    /**
     * Total time elapsed since page load
     */
    time_since_page_load?: number;
    /**
     * Total time since the previous load event
     */
    time_since_prev_event?: number;
    video_url_suffix?:      string;
    [property: string]: any;
}

/**
 * What phase of the load event is occurring. Can be one of six values.
 */
export enum LoadEventName {
    Mounted = "mounted",
    Ready = " ready",
    RequestFragmentEnd = "request_fragment_end",
    RequestFragmentStart = " request_fragment_start",
    RequestManifest = "request_manifest",
    RequestPlaylist = " request_playlist",
}

export interface PlaylistClick {
    event_time?:     string;
    playlist_id?:    string;
    playlistId?:     string;
    schedule_id?:    string;
    schedule_index?: number;
    scheduleIndex?:  string;
    [property: string]: any;
}

/**
 * User successfully creates, edits, or deletes a playlist. Actions can also include adding,
 * removing, or re-ordering classes in the playlist.
 */
export interface PlaylistsEditPlaylist {
    /**
     * The playlist action the user is taking.
     */
    action: string;
    /**
     * The ID of the class that was added or removed from playlist.
     */
    class_id?: string;
    /**
     * The general location where the playlist action occurred.
     */
    location: string;
    /**
     * The page where the playlist action occurred.
     */
    module: string;
    /**
     * The ID of the playlist.
     */
    playlist_id: string;
    /**
     * The name of the playlist.
     */
    playlist_name?: string;
    /**
     * The privacy setting of the playlist.
     */
    privacy?: string;
    [property: string]: any;
}

/**
 * User selects an element on the Playlists page.
 */
export interface PlaylistsSelectElement {
    /**
     * Name of the element.
     */
    element_name: string;
    /**
     * Name of the element.
     */
    element_type: string;
    /**
     * The general location where the element was selected.
     */
    location: string;
    /**
     * The page where the element was selected.
     */
    module: string;
    [property: string]: any;
}

/**
 * User viewing one of the Playlist screens.
 */
export interface PlaylistsViewScreen {
    /**
     * The general location where the element was viewed.
     */
    location: string;
    /**
     * The page where the element was viewed.
     */
    module: string;
    /**
     * Name of the screen being viewed.
     */
    screen_name: string;
    [property: string]: any;
}

/**
 * user clicks on the Steezy Family item from the Account section of Profile, bringing them
 * to the Steezy Family screen (marketing OR manage based on whether pin is enabled already)
 */
export interface ProfileSelectElement {
    element_name?: string;
    element_type?: string;
    location?:     string;
    module?:       string;
    pin_enabled?:  boolean;
    [property: string]: any;
}

/**
 * Called when the user clicks the CTA to open the Referrals Screen
 */
export interface ReferralOpenCTA {
    account_status: string;
    element_copy?:  string;
    element_type:   string;
    location:       string;
    module:         string;
    [property: string]: any;
}

/**
 * User clicked on available credits row
 */
export interface ReferralSelectAvailableCredits {
    /**
     * Number of credits available in whole dollars
     */
    credits_available?: number;
    element_copy:       string;
    element_type:       string;
    location:           string;
    module:             string;
    [property: string]: any;
}

/**
 * User clicked on classes to unlock row
 */
export interface ReferralSelectClassesToUnlock {
    classes_available?: number;
    element_copy:       string;
    element_type:       string;
    location:           string;
    module:             string;
    [property: string]: any;
}

/**
 * User clicked on invite history
 */
export interface ReferralSelectInviteHistory {
    element_copy: string;
    element_type: string;
    location:     string;
    module:       string;
    [property: string]: any;
}

/**
 * User clicked on share invite button
 */
export interface ReferralSelectShareButton {
    element_copy: string;
    element_type: string;
    location:     string;
    module:       string;
    [property: string]: any;
}

/**
 * User clicked on terms and conditions
 */
export interface ReferralSelectTermsAndConditions {
    element_copy: string;
    element_type: string;
    location:     string;
    module:       string;
    [property: string]: any;
}

/**
 * User clicked on view classes button from modal
 */
export interface ReferralSelectViewClassesButton {
    element_copy: string;
    element_type: string;
    location:     string;
    module:       string;
    [property: string]: any;
}

/**
 * User clicked on unlocked classes row
 */
export interface ReferralSelectViewUnlockedClasses {
    classes_unlocked?: number;
    element_copy:      string;
    element_type:      string;
    location:          string;
    module:            string;
    [property: string]: any;
}

export interface ReferralUnlockClass {
    class_id?:     string;
    element_copy?: null | string;
    element_type?: null | string;
    location?:     string;
    module?:       string;
    [property: string]: any;
}

export interface ReferralViewModal {
    element_copy: string;
    element_name: string;
    element_type: string;
    location:     string;
    module:       string;
    [property: string]: any;
}

export interface ScreenViewed {
    "Class Name"?: any;
    Screen?:       any;
    [property: string]: any;
}

export interface SearchSearchClasses {
    hits?:   any;
    query?:  any;
    search?: string;
    [property: string]: any;
}

/**
 * fires when user selects content from Search
 */
export interface SearchSelectContent {
    /**
     * Can be studio or family
     */
    account_mode?: AccountMode;
    /**
     * title of the section the content is in (must be in snake_case)
     */
    container?: string;
    /**
     * id of selected content
     */
    content_id?: string;
    /**
     * name of selected content
     */
    content_name?: string;
    /**
     * type of selected content
     */
    content_type?: string;
    /**
     * content type
     */
    element_type?: string;
    /**
     * location content was selected from
     */
    location?: string;
    /**
     * ex: "search_all_results", "search_classes"
     */
    module?: string;
    /**
     * query text typed into search box
     */
    search_text?: string;
    [property: string]: any;
}

export interface SelectElement {
    element_name?:    string;
    event_time?:      string;
    location?:        string;
    lookback_delta?:  number;
    module?:          string;
    platform?:        string;
    taken_list_date?: string;
    [property: string]: any;
}

/**
 * User purchases a new subscription without trial (user completes Checkout, not eligible
 * for Trial)
 */
export interface SubscribeAddSubscription {
    coupon?:             any;
    daypart?:            any;
    days_since_created?: any;
    /**
     * The value of the coupon code (either the plan_price * % off, or the flat discount amount).
     */
    discount?:                  any;
    discount_amount?:           any;
    discount_percent?:          any;
    order_id?:                  any;
    path?:                      any;
    payment_method?:            any;
    plan?:                      any;
    plan_price?:                any;
    plan_price_after_discount?: any;
    platform?:                  string;
    product_id?:                any;
    products?:                  SubscribeAddSubscriptionProduct[];
    subscription_id?:           any;
    /**
     * The subscription's provider platform (e.g. Chargebee, RevenueCat, etc.)
     */
    subscription_provider?:     string;
    subscription_renewal_date?: Date;
    subscription_start_date?:   Date;
    trial_length?:              any;
    utm_campaign?:              any;
    utm_content?:               any;
    utm_medium?:                any;
    utm_source?:                any;
    variant?:                   string;
    [property: string]: any;
}

export interface SubscribeAddSubscriptionProduct {
    price?:      number;
    product_id?: string;
    quantity?:   number;
    [property: string]: any;
}

export interface SubscribeRestoreSubscription {
    active_entitlements?:     ActiveEntitlements;
    active_subscriptions?:    string[];
    all_purchased_productid?: string[];
    first_seen?:              any;
    latest_expiration_date?:  any;
    original_app_userid?:     any;
    purchaserInfo?:           any;
    request_date?:            any;
    [property: string]: any;
}

export interface ActiveEntitlements {
    subscription?: string;
    [property: string]: any;
}

export interface SubscribeSelectPaymentMethod {
    path?:           any;
    payment_method?: any;
    plan?:           any;
    [property: string]: any;
}

export interface SubscribeSelectPlan {
    /**
     * where the modal was inflated from
     */
    module?:  string;
    path?:    any;
    plan?:    string;
    variant?: any;
    [property: string]: any;
}

export interface UsePlaybackControl {
    adjusted_to?:       any;
    adjustment_type?:   string;
    cast_control?:      string;
    class_id?:          number;
    classId?:           number;
    control_used?:      string;
    create_loop?:       number[];
    cuepoint_name?:     string;
    end_loop?:          boolean;
    in_a_party?:        boolean;
    mirrored?:          string;
    party_session_id?:  string;
    playback_time?:     string;
    section_name?:      string;
    section_selected?:  string;
    skip_to?:           string;
    toggle_camera?:     boolean;
    toggle_fullscreen?: boolean;
    toggled_to?:        string;
    volume_set_to?:     number;
    [property: string]: any;
}

export interface UseVideoPartyControl {
    mute?:             boolean;
    party_session_id?: string;
    video?:            boolean;
    [property: string]: any;
}

/**
 * Ajv is a peer dependency for development builds. It's used to apply run-time validation
 * to message payloads before passing them on to the underlying analytics instance.
 *
 * Note that the production bundle does not depend on Ajv.
 * 
 * You can install it with: `npm install --save-dev ajv`.
 */
import Ajv, { ErrorObject } from 'ajv'

/**
 * The analytics.js snippet should be available via window.analytics.
 * You can install it by following instructions at: https://segment.com/docs/sources/website/analytics.js/quickstart/
 * Make sure to also include the TypeScript declarations with: `npm install --dev @types/segment-analytics`
 */
 declare global {
    interface Window {
        analytics: SegmentAnalytics.AnalyticsJS
    }
}

/** The callback exposed by analytics.js. */
export type Callback = () => void

/** A dictionary of options. For example, enable or disable specific destinations for the call. */
export interface Options {
    /**
     * Selectivly filter destinations. By default all destinations are enabled.
     * https://segment.com/docs/sources/website/analytics.js/#selecting-destinations
     */
    integrations?: {
        [key: string]: boolean | { [key: string]: any }
    }
    /**
     * A dictionary of extra context to attach to the call.
     * https://segment.com/docs/spec/common/#context
     */
    context?: Context
}

/**
 * Context is a dictionary of extra information that provides useful context about a datapoint.
 * @see {@link https://segment.com/docs/spec/common/#context}
 */
export interface Context extends Record<string, any> {
    active?: boolean
    app?: {
        name?: string
        version?: string
        build?: string
    }
    campaign?: {
        name?: string
        source?: string
        medium?: string
        term?: string
        content?: string
    }
    device?: {
        id?: string
        manufacturer?: string
        model?: string
        name?: string
        type?: string
        version?: string
    }
    ip?: string
    locale?: string
    location?: {
        city?: string
        country?: string
        latitude?: string
        longitude?: string
        region?: string
        speed?: string
    }
    network?: {
        bluetooth?: string
        carrier?: string
        cellular?: string
        wifi?: string
    }
    os?: {
        name?: string
        version?: string
    }
    page?: {
        hash?: string
        path?: string
        referrer?: string
        search?: string
        title?: string
        url?: string
    }
    referrer?: {
        type?: string
        name?: string
        url?: string
        link?: string
    }
    screen?: {
        density?: string
        height?: string
        width?: string
    }
    timezone?: string
    groupId?: string
    traits?: Record<string, any>
    userAgent?: string
}

export type ViolationHandler = (
    message: Record<string, any>,
    violations: ErrorObject[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (message, violations) => {
    const msg = JSON.stringify(
        {
            type: 'Typewriter JSON Schema Validation Error',
            description:
                `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
                'Tracking Plan spec.',
            errors: violations,
        },
        undefined,
        2,
    );

    console.warn(msg);
};

let onViolation = defaultValidationErrorHandler

let analytics: () => SegmentAnalytics.AnalyticsJS | undefined = () => {
    return window.analytics;
};

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
    /**
     * Underlying analytics instance where analytics calls are forwarded on to.
     * Defaults to window.analytics.
     */
    analytics?: SegmentAnalytics.AnalyticsJS;
    /**
     * Handler fired when if an event does not match its spec. This handler
     * does not fire in production mode, because it requires inlining the full
     * JSON Schema spec for each event in your Tracking Plan.
     *
     * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
     * if a message does not match the spec. Otherwise, errors will be logged to stderr.
     */
    onViolation?: ViolationHandler;
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
    analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
    onViolation = options.onViolation || onViolation
}

/**
    * Validates a message against a JSON Schema using Ajv. If the message
    * is invalid, the `onViolation` handler will be called.
    */
function validateAgainstSchema(
    message: Record<string, any>,
    schema: object
) {
    const ajv = new Ajv({ allErrors: true, verbose: true })

    if (!ajv.validate(schema, message) && ajv.errors) {
        onViolation(message, ajv.errors)
    }
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Options = {}): Options {
    return {
        ...message,
        context: {
            ...(message.context || {}),
            typewriter: {
                language: 'typescript',
                version: '8.1.0',
            },
        },
    };
}

/**
 * Fires a 'ApplicationInstalled' track call.
 *
 * @param ApplicationInstalled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function applicationInstalled(props: ApplicationInstalled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Application_Installed","$schema":"http://json-schema.org/draft-07/schema#","description":"User installed application","properties":{"build":{"description":"Current application build","type":"string"},"version":{"description":"Current application version","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Application Installed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ApplicationOpened' track call.
 *
 * @param ApplicationOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function applicationOpened(props: ApplicationOpened, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Application_Opened","$schema":"http://json-schema.org/draft-07/schema#","description":"User opened application","properties":{"build":{"description":"Current application build","type":"string"},"from_background":{"type":"boolean"},"referring_application":{"type":"string"},"url":{"description":"Referring application url","type":"string"},"version":{"description":"Current application version","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Application Opened', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ApplicationUpdated' track call.
 *
 * @param ApplicationUpdated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function applicationUpdated(props: ApplicationUpdated, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Application_Updated","$schema":"http://json-schema.org/draft-07/schema#","description":"User updated application","properties":{"build":{"description":"Current application build","type":"string"},"previous_build":{"description":"Previous application build","type":"string"},"previous_version":{"description":"Previous application version","type":"string"},"version":{"description":"Current application version","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Application Updated', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CancelClick' track call.
 *
 * @param CancelClick props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function cancelClick(props: CancelClick, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Cancel_-_Click","$schema":"http://json-schema.org/draft-07/schema#","properties":{"plan":{},"topic":{},"trialing":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Cancel - Click', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CancelRating' track call.
 *
 * @param CancelRating props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function cancelRating(props: CancelRating, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Cancel_-_Rating","$schema":"http://json-schema.org/draft-07/schema#","properties":{"plan":{},"stars":{},"trialing":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Cancel - Rating', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CancelReason' track call.
 *
 * @param CancelReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function cancelReason(props: CancelReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Cancel_-_Reason","$schema":"http://json-schema.org/draft-07/schema#","properties":{"cancel_option":{},"feeback":{},"plan":{},"topic":{},"trialing":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Cancel - Reason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CastClass' track call.
 *
 * @param CastClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function castClass(props: CastClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Cast_-_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User initiated casting from mobile app","properties":{"categories ":{"type":"string"},"classId":{"type":"integer"},"class_id":{"type":"integer"},"class_name":{"type":"string"},"content_locked":{"description":"","type":"boolean"},"instructor":{"type":"string"},"level":{"type":"string"},"method":{"type":"string"},"program_slug":{"type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"stream_method":{"description":"The streaming method the class is being viewed","type":"string"},"style":{"description":"Class style","type":"string"},"time":{"type":"string"},"title":{"type":"string"},"type":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Cast - Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CheckoutSelectElement' track call.
 *
 * @param CheckoutSelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function checkoutSelectElement(props: CheckoutSelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Checkout_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","description":"User taps “Try Free & Subscribe”","properties":{"element_copy":{"description":"ex. \"Try Free & Subscribe\"","type":"string"},"element_name":{"description":"ex. \"Annual Plan Button\"","type":"string"},"element_type":{"description":"ex. \"Button\"","type":"string"},"location":{"description":"ex. \"Checkout - Main\"","type":"string"},"module":{"description":"ex. \"onboarding\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Checkout - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CheckoutSelectReferralsLearnMore' track call.
 *
 * @param CheckoutSelectReferralsLearnMore props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function checkoutSelectReferralsLearnMore(props: CheckoutSelectReferralsLearnMore, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Checkout_-_Select_Referrals_Learn_More","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on learn more in subscription dialog","properties":{"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Checkout - Select Referrals Learn More', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CheckoutViewCheckout' track call.
 *
 * @param CheckoutViewCheckout props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function checkoutViewCheckout(props: CheckoutViewCheckout, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Checkout_-_View_Checkout","$schema":"http://json-schema.org/draft-07/schema#","description":"User views new checkout page","properties":{"gclid":{"description":"Google Click Identifier","type":"string"},"location":{"description":"location/screen that checkout page was viewed","type":"string"},"module":{"description":"ex. \"onboarding, premium tab\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Checkout - View Checkout', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CheckoutViewModal' track call.
 *
 * @param CheckoutViewModal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function checkoutViewModal(props: CheckoutViewModal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Checkout_-_View_Modal","$schema":"http://json-schema.org/draft-07/schema#","description":"User views Monthly Modal (ie they tapped “I’d rather pay monthly”)","properties":{"element_copy":{"description":"","type":"string"},"element_name":{"description":"\"[Plan] Option Button\"","type":"string"},"element_type":{"description":"ex. \"Button\"","type":"string"},"location":{"description":"ex. \"Checkout - Main\"","type":"string"},"module":{"description":"ex. \"onboarding\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Checkout - View Modal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassCompleteClass' track call.
 *
 * @param ClassCompleteClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classCompleteClass(props: ClassCompleteClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Complete_Class","$schema":"http://json-schema.org/draft-07/schema#","properties":{"":{"description":"","type":"object"},"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"categories":{"items":{"type":"string"},"type":"array"},"class_id ":{"description":"Class identifier","type":"number"},"content_locked":{"description":"","type":"boolean"},"instructor":{"description":"Class instructor","type":"string"},"level":{"description":"Class difficulty level","type":"string"},"saved":{"description":"Identify if the class is Saved in user preferences","type":"boolean"},"stream_method":{"description":"The streaming method the class is being viewed","type":"string"},"style":{"description":"Class style","type":"string"},"title":{"description":"Class title","type":"string"},"type":{"description":"Class type","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Complete Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassContinueClass' track call.
 *
 * @param ClassContinueClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classContinueClass(props: ClassContinueClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Continue_Class","$schema":"http://json-schema.org/draft-07/schema#","properties":{"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"categories":{"items":{"type":"string"},"type":"array"},"categories ":{"type":"string"},"class_id":{},"content_locked":{"description":"","type":"boolean"},"daypart":{},"demo":{},"instructor":{},"level":{},"program_slug":{"type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"stream_method":{"description":"The streaming method the class is being viewed","type":"string"},"style":{"description":"Class style","type":"string"},"title":{},"type":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Continue Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassDownloadClass' track call.
 *
 * @param ClassDownloadClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classDownloadClass(props: ClassDownloadClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Download_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User initiated class download in mobile app","properties":{"categories ":{"description":"A list of category slugs associated with the class","items":{"description":"Category slugs","type":"string"},"type":"array"},"class_id ":{"description":"The ID of the class","type":"integer"},"instructor":{"description":"The full name of the instructor of the class","type":"string"},"level":{"description":"The difficulty level of the class","type":"string"},"program_slug":{"description":"The slug of the associated program","type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"style":{"description":"Class style","type":"string"},"title":{"description":"The title of the class","type":"string"},"type":{"description":"The type of the class","type":"string"}},"required":["class_id "],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Download Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassDownloadComplete' track call.
 *
 * @param ClassDownloadComplete props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classDownloadComplete(props: ClassDownloadComplete, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Download_Complete","$schema":"http://json-schema.org/draft-07/schema#","properties":{"class_id":{"type":"integer"},"instructor":{"type":"string"},"level":{"type":"string"},"style":{"description":"Class style","type":"string"},"title":{"type":"string"},"type":{"type":"string"}},"required":["class_id"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Download Complete', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassEndClass' track call.
 *
 * @param ClassEndClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classEndClass(props: ClassEndClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_End_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User ended class","properties":{"categories":{"description":"","items":{"type":"string"},"type":"array"},"class_id":{"description":"Class identifier","type":"integer"},"content_locked":{"description":"","type":"boolean"},"daypart":{},"demo":{},"instructor":{"description":"Class instructor","type":"string"},"level":{"description":"Class level","type":"string"},"method":{"description":"Method user utilized to exit the class player","type":"string"},"percent_completed":{"description":"Amount of total class taken; reviewing a section does not contribute to increased percent_complete","type":"number"},"percent_progress":{"description":"Relative position on video Progress Bar","type":"number"},"program_slug":{"description":"Programs associated with class","type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"stream_method":{"description":"The streaming method the class is being viewed","type":"string"},"style":{"description":"Class style","type":"string"},"title":{"description":"Class Title","type":"string"},"type":{}},"required":["class_id"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - End Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassOpenClass' track call.
 *
 * @param ClassOpenClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classOpenClass(props: ClassOpenClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Open_Class","$schema":"http://json-schema.org/draft-07/schema#","properties":{"categories":{"type":"string"},"classId":{},"classId ":{},"class_id ":{},"instructor":{},"level":{},"program_slug":{"type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"style":{"description":"Class style","type":"string"},"title":{},"type":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Open Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassPause' track call.
 *
 * @param ClassPause props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classPause(props: ClassPause, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Pause","$schema":"http://json-schema.org/draft-07/schema#","properties":{"casting":{"type":"string"},"classId":{},"classId ":{},"class_id ":{},"instructor":{},"level":{},"style":{"description":"Class style","type":"string"},"time":{},"title":{},"type":{},"view":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Pause', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassPauseClass' track call.
 *
 * @param ClassPauseClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classPauseClass(props: ClassPauseClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Pause_Class","$schema":"http://json-schema.org/draft-07/schema#","properties":{"classId ":{},"instructor":{},"level":{},"style":{"description":"Class style","type":"string"},"title":{},"type":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Pause Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassPlay' track call.
 *
 * @param ClassPlay props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classPlay(props: ClassPlay, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Play","$schema":"http://json-schema.org/draft-07/schema#","properties":{"casting":{"type":"string"},"classId":{},"classId ":{},"class_id ":{},"instructor":{},"level":{},"style":{"description":"Class style","type":"string"},"time":{},"title":{},"type":{},"view":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Play', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassPlayerBuffering' track call.
 *
 * @param ClassPlayerBuffering props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classPlayerBuffering(props: ClassPlayerBuffering, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Player_Buffering","$schema":"http://json-schema.org/draft-07/schema#","properties":{"categories":{"properties":{"dance-workout":{"type":["boolean"]},"dancehall":{"type":["boolean"]},"heels":{"type":["boolean"]},"house":{"type":["boolean"]},"popular-choreography":{"type":["boolean"]},"tips-and-lectures":{"type":["boolean"]}},"type":"object"},"class_id":{},"completedAllOtherClassesInProgram":{"type":"boolean"},"credits":{"type":"string"},"current_time_in_seconds":{},"date_allowed":{"type":"string"},"duration":{"type":"string"},"duration_group":{"type":"string"},"duration_in_seconds":{"type":"integer"},"event":{"properties":{"isTrusted":{"type":["boolean"]}},"type":"object"},"explicit":{"type":"boolean"},"free":{"type":"boolean"},"id":{"type":"integer"},"instructor":{},"instructor_name":{"type":"string"},"instructor_slug":{"type":"string"},"isFree":{"type":"boolean"},"isLastClass":{"type":"boolean"},"isPurchased":{"type":"boolean"},"keywords":{"items":{"type":"string"},"type":"array"},"lastModifiedDate":{"type":"string"},"level":{},"model_name":{"type":"string"},"playlists":{"properties":{"7-days-of-steezy-0":{"type":["string"]},"7-days-of-steezy-1":{"type":["string"]},"7-days-of-steezy-2":{"type":["string"]},"7-days-of-steezy-3":{"type":["string"]},"7-days-of-steezy-4":{"type":["string"]},"7-days-of-steezy-5":{"type":["string"]},"7-days-of-steezy-6":{"type":["string"]}},"type":"object"},"preview_url":{"type":"string"},"programs":{"items":{"type":"string"},"type":"array"},"publish_date":{"type":"string"},"schedules":{"properties":{"7-days-of-steezy":{"type":["string"]}},"type":"object"},"slug":{"type":"string"},"songs":{"items":{"properties":{"apple_music":{"type":["string"]},"artist":{"type":["string"]},"explicit":{"type":["boolean"]},"spotify":{"type":["string"]},"title":{"type":["string"]},"youtube":{"type":["string"]}},"type":"object"},"type":"array"},"style":{"description":"Class style","type":"string"},"style_slug":{"type":"string"},"styles":{"description":"List of associated styles","items":{"type":"string"},"type":"array"},"styles_query":{"properties":{"b-boying":{"type":["boolean"]},"dance-workout":{"type":["boolean"]},"dancehall":{"type":["boolean"]},"heels":{"type":["boolean"]},"hip-hop":{"type":["boolean"]},"house":{"type":["boolean"]},"jazz-funk":{"type":["boolean"]},"kpop":{"type":["boolean"]},"krump":{"type":["boolean"]},"lite-feet":{"type":["boolean"]},"locking":{"type":["boolean"]},"open-style":{"type":["boolean"]},"popping":{"type":["boolean"]},"popular-dances":{"type":["boolean"]},"tiktok-dances":{"type":["boolean"]},"urban-dance":{"type":["boolean"]},"warmup-and-stretches":{"type":["boolean"]},"whacking":{"type":["boolean"]},"workout":{"type":["boolean"]}},"type":"object"},"techniques":{"items":{"type":"string"},"type":"array"},"techniques_query":{"properties":{"control":{"type":["boolean"]},"floorwork":{"type":["boolean"]},"footwork":{"type":["boolean"]},"foundation":{"type":["boolean"]},"groove":{"type":["boolean"]},"isolation":{"type":["boolean"]},"speed":{"type":["boolean"]},"strength":{"type":["boolean"]},"texture":{"type":["boolean"]},"undefined":{"type":["boolean"]}},"type":"object"},"techniques_slugs":{"items":{"type":"string"},"type":"array"},"thumbnail":{"type":"string"},"title":{},"type":{},"url":{"type":"string"},"video_url":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Player Buffering', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassReviewClass' track call.
 *
 * @param ClassReviewClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classReviewClass(props: ClassReviewClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Review_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User returned to take class again","properties":{"categories":{"items":{"type":"string"},"type":"array"},"categories ":{"type":"string"},"classId":{"type":"integer"},"class_id":{},"class_id ":{},"content_locked":{"description":"","type":"boolean"},"daypart":{},"demo":{},"instructor":{"type":"string"},"level":{"type":"string"},"location":{"description":"","type":"string"},"program_block_index":{"description":"","type":["integer","null"]},"program_block_title":{"description":"","type":"string"},"program_section_index":{"description":"","type":["integer","null"]},"program_section_title":{"description":"","type":"string"},"program_slug":{"type":"string"},"program_title":{"description":"Title of program being taken","type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"stream_method":{"description":"The streaming method the class is being viewed","type":"string"},"style":{"description":"Class style","type":"string"},"title":{"type":"string"},"type":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Review Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassReviewSection' track call.
 *
 * @param ClassReviewSection props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classReviewSection(props: ClassReviewSection, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Review_Section","$schema":"http://json-schema.org/draft-07/schema#","properties":{"casting":{"type":"string"},"classId":{},"classId ":{},"class_id ":{},"instructor":{},"level":{},"style":{"description":"Class style","type":"string"},"time":{},"time ":{},"title":{},"type":{},"view":{},"view ":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Review Section', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassSkip' track call.
 *
 * @param ClassSkip props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classSkip(props: ClassSkip, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Skip","$schema":"http://json-schema.org/draft-07/schema#","properties":{"casting":{"type":"string"},"classId":{},"class_id ":{},"direction":{},"direction ":{},"instructor":{},"level":{},"style":{"description":"Class style","type":"string"},"time":{},"time ":{},"title":{},"type":{},"view":{},"view ":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Skip', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassSkipSection' track call.
 *
 * @param ClassSkipSection props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classSkipSection(props: ClassSkipSection, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Skip_Section","$schema":"http://json-schema.org/draft-07/schema#","properties":{"casting":{"type":"boolean"},"classId":{"type":"integer"},"classId ":{},"class_id ":{},"direction":{"type":"string"},"direction ":{},"instructor":{},"level":{},"style":{"description":"Class style","type":"string"},"time":{"type":"string"},"time ":{},"title":{},"type":{},"view":{"type":"string"},"view ":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Skip Section', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassSpeed' track call.
 *
 * @param ClassSpeed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classSpeed(props: ClassSpeed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Speed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"casting":{"type":"string"},"level":{},"speed":{},"style":{"description":"Class style","type":"string"},"title":{},"type":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Speed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassStartClass' track call.
 *
 * @param ClassStartClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classStartClass(props: ClassStartClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Start_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User started Class for the first time. Event is designed to fire the first time a user starts a Class in each app","properties":{"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"categories":{"items":{"type":"string"},"type":"array"},"categories ":{"type":"string"},"classId":{},"class_id":{},"content_locked":{"description":"","type":"boolean"},"daypart":{},"demo":{},"instructor":{},"level":{},"location":{"description":"","type":"string"},"playlist_id":{"description":"The ID of the playlist that the class is starting from.","type":"string"},"program_block_index":{"description":"","type":"integer"},"program_block_title":{"description":"","type":"string"},"program_section_index":{"description":"","type":"integer"},"program_section_title":{"description":"","type":"string"},"program_slug":{"type":"string"},"program_title":{"description":"","type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"stream_method":{"description":"The streaming method the class is being viewed","type":"string"},"style":{"description":"Class style","type":"string"},"title":{},"type":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Start Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassSwitchView' track call.
 *
 * @param ClassSwitchView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classSwitchView(props: ClassSwitchView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Switch_View","$schema":"http://json-schema.org/draft-07/schema#","properties":{"casting":{"type":"string"},"classId":{},"time":{},"view":{},"view ":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Switch View', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassTakingClass' track call.
 *
 * @param ClassTakingClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classTakingClass(props: ClassTakingClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Taking_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"Tracks the user's current state and progression while they are taking a class. The event is triggered at an interval based on the value provided in the \"interval\" attribute","properties":{"camera":{"description":"True if the user's webcam is enabled","type":"boolean"},"categories":{"description":"A list of categories associated with the class","items":{"type":"string"},"type":"array"},"class_id":{"description":"The ID of the class","type":"integer"},"content_locked":{"description":"","type":"boolean"},"daypart":{"description":"When the user is watching the class","type":"string"},"instructor":{"description":"The instructor of the class","type":"string"},"interval":{"description":"How often the event is being triggered in seconds","type":"integer"},"level":{"description":"The level of the class"},"looping":{"description":"True if the user is looping the class","type":"boolean"},"mirrored":{"description":"True if the user is mirroring the class","type":"boolean"},"percent_progress":{"description":"What percentage of the class they are currently viewing. Current timestamp / Total duration","type":"number"},"program_slug":{"description":"The associated program slug","type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"session_minute_reached":{},"stream_method":{"description":"The streaming method the class is being viewed","type":"string"},"style":{"description":"The style of the class","type":"string"},"title":{"description":"The title of the class","type":"string"},"type":{"description":"The type of the class","type":"string"},"view":{"description":"Whether the class is being viewed from the front or back","enum":["back","front"],"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Taking Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClassToggleMirror' track call.
 *
 * @param ClassToggleMirror props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function classToggleMirror(props: ClassToggleMirror, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Class_-_Toggle_Mirror","$schema":"http://json-schema.org/draft-07/schema#","properties":{"classId":{"type":"integer"},"mirror":{"type":"string"},"time":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Class - Toggle Mirror', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClickExternalLink' track call.
 *
 * @param ClickExternalLink props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function clickExternalLink(props: ClickExternalLink, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Click_-_External_Link","$schema":"http://json-schema.org/draft-07/schema#","properties":{"service":{},"url":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Click - External Link', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClickLink' track call.
 *
 * @param ClickLink props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function clickLink(props: ClickLink, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Click_-_Link","$schema":"http://json-schema.org/draft-07/schema#","properties":{"destination":{},"in_component":{},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Click - Link', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ClickShare' track call.
 *
 * @param ClickShare props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function clickShare(props: ClickShare, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Click_-_Share","$schema":"http://json-schema.org/draft-07/schema#","properties":{"component":{},"path":{},"platform":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Click - Share', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CommunityContentFlag' track call.
 *
 * @param CommunityContentFlag props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function communityContentFlag(props: CommunityContentFlag, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Community_-_Content_Flag","$schema":"http://json-schema.org/draft-07/schema#","properties":{"challenge_active":{"description":"","type":"boolean"},"challenge_id":{"description":"","type":"string"},"content_id":{"description":"","type":"string"},"content_type":{"description":"","enum":["user_video","comment"],"type":"string"},"content_user_id":{"description":"","type":"string"},"element_name":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"},"reason":{"description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Community - Content Flag', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CommunitySelectElement' track call.
 *
 * @param CommunitySelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function communitySelectElement(props: CommunitySelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Community_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","description":"When a user selects a UI element on Steezy's Community feature","properties":{"element_copy":{"description":"The copy of the element","type":"string"},"element_name":{"description":"The proper name of the element","type":"string"},"element_type":{"description":"The type of element i.e. \"button\"","type":"string"},"location":{"description":"The domain within our app this event took place","type":"string"},"module":{"description":"A feature within a domain this event took place","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Community - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CommunitySubmitComment' track call.
 *
 * @param CommunitySubmitComment props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function communitySubmitComment(props: CommunitySubmitComment, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Community_-_Submit_Comment","$schema":"http://json-schema.org/draft-07/schema#","properties":{"challenge_active":{"description":"","type":"boolean"},"challenge_id":{"description":"","type":"string"},"comment_length":{"description":"","type":"integer"},"content_id":{"description":"","type":"string"},"content_type":{"description":"","type":"string"},"content_user_id":{"description":"","type":"string"},"element_name":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Community - Submit Comment', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CommunityVideoActivity' track call.
 *
 * @param CommunityVideoActivity props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function communityVideoActivity(props: CommunityVideoActivity, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Community_-_Video_Activity","$schema":"http://json-schema.org/draft-07/schema#","description":"Activity that occurs on a user video that includes comments, likes, and replies.","properties":{"comment_id":{"description":"The ID of the comment.","type":"string"},"to_user_id":{"description":"The UID of the user that the action is going to.","type":"string"},"type":{"description":"The type of activity that occurred on the video.","enum":["like","unlike","comment","reply","view"],"type":"string"},"video_id":{"description":"The ID of the video.","type":"string"}},"required":["type","video_id","to_user_id"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Community - Video Activity', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CommunityViewCommunityGuidelines' track call.
 *
 * @param CommunityViewCommunityGuidelines props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function communityViewCommunityGuidelines(props: CommunityViewCommunityGuidelines, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Community_-_View_Community_Guidelines","$schema":"http://json-schema.org/draft-07/schema#","description":"Event should fire when the Community Rules modal is loaded for the user.","properties":{"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Community - View Community Guidelines', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentFilterClasses' track call.
 *
 * @param ContentFilterClasses props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentFilterClasses(props: ContentFilterClasses, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Filter_Classes","$schema":"http://json-schema.org/draft-07/schema#","properties":{"categories":{"items":{"type":"string"},"type":"string"},"class_duration_in_seconds":{"type":"string"},"class_lengths":{"items":{"type":"string"},"type":"array"},"hideExplicit":{"items":{"type":"string"},"type":"array"},"instructor_name":{"type":"string"},"instructors":{"items":{"type":"string"},"type":"array"},"levels":{"items":{"type":"string"},"type":"array"},"mood":{"type":"array"},"path":{},"selectedInstructor":{"items":{"type":"string"},"type":"array"},"showDownloadOnly":{"type":"boolean"},"sort":{"items":{"type":"string"},"type":"array"},"style":{"description":"Class style","type":"string"},"styles":{"description":"List of associated styles","items":{"type":"string"},"type":"array"},"types":{"items":{"type":"string"},"type":"array"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Filter Classes', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentFilterPrograms' track call.
 *
 * @param ContentFilterPrograms props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentFilterPrograms(props: ContentFilterPrograms, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Filter_Programs","$schema":"http://json-schema.org/draft-07/schema#","properties":{"categories":{"items":{"type":"string"},"type":"array"},"levels":{"items":{"type":"string"},"type":"array"},"path":{},"sort":{},"styles":{"description":"List of associated class styles","items":{"type":"string"},"type":"array"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Filter Programs', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentPreviewClass' track call.
 *
 * @param ContentPreviewClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentPreviewClass(props: ContentPreviewClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Preview_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User engages with class preview video","properties":{"categories":{"items":{"type":"string"},"type":"array"},"class_id":{"type":"integer"},"content_locked":{"description":"","type":"boolean"},"duration":{},"instructor":{},"is_preview_video_muted":{"type":"boolean"},"level":{"items":{"type":"string"},"type":"array"},"location":{"description":"","type":"string"},"path":{},"program_slug":{"type":"string"},"program_style":{},"program_title":{},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"selected_from":{"type":"string"},"style":{"description":"Class style","type":"string"},"title":{},"type":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Preview Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentPreviewProgram' track call.
 *
 * @param ContentPreviewProgram props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentPreviewProgram(props: ContentPreviewProgram, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Preview_Program","$schema":"http://json-schema.org/draft-07/schema#","description":"User engages with program preview video","properties":{"categories":{"items":{"type":"string"},"type":"array"},"classId":{"type":"integer"},"content_locked":{"description":"","type":"boolean"},"duration":{"type":"integer"},"instructor":{"type":"string"},"level":{"type":"string"},"path":{},"program_slug":{"type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"selected_from":{"type":"string"},"style":{"description":"Class style","type":"string"},"title":{"type":"string"},"type":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Preview Program', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentSelectCategory' track call.
 *
 * @param ContentSelectCategory props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentSelectCategory(props: ContentSelectCategory, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Select_Category","$schema":"http://json-schema.org/draft-07/schema#","properties":{"categories":{"items":{"type":"string"},"type":"array"},"event_time":{"type":"string"},"module":{"type":"string"},"path":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Select Category', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentSelectClass' track call.
 *
 * @param ContentSelectClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentSelectClass(props: ContentSelectClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Select_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects Class from UI","properties":{"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"categories":{"items":{"type":"string"},"type":"array"},"categories ":{"type":"string"},"class_id":{"type":"integer"},"class_list_index_location":{"type":"integer"},"class_navigation_count":{"type":"integer"},"class_title":{},"content_locked":{"description":"","type":"boolean"},"event_time":{"type":"string"},"location":{"description":"","type":"string"},"path":{},"playlist_id":{"description":"The ID of the playlist that the class is selected from.","type":"string"},"previous_class_id":{},"program_level":{"items":{"type":"string"},"type":"array"},"program_slug":{"type":"string"},"program_style":{},"program_title":{},"selected_from":{},"title":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Select Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentSelectElement' track call.
 *
 * @param ContentSelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentSelectElement(props: ContentSelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","properties":{"class_id":{"type":"string"},"class_title":{"type":"string"},"element_name":{"type":"string"},"element_type":{"type":"string"},"location":{"type":"string"},"module":{"type":"string"},"playlist_id":{"type":"string"},"taken_list_date":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentSelectPlaylist' track call.
 *
 * @param ContentSelectPlaylist props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentSelectPlaylist(props: ContentSelectPlaylist, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Select_Playlist","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects a playlist to view.","properties":{"location":{"description":"The general location where the playlist was selected.","type":"string"},"module":{"description":"The page where the playlist was selected.","type":"string"},"playlist_id":{"description":"The ID of the playlist.","type":"string"},"playlist_name":{"description":"The name of the playlist.","type":"string"},"playlist_user_id":{"description":"The user ID of the owner of the playlist or 'steezy'.","type":"string"}},"required":["playlist_id","playlist_name","playlist_user_id","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Select Playlist', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentSelectProgram' track call.
 *
 * @param ContentSelectProgram props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentSelectProgram(props: ContentSelectProgram, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Select_Program","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects Program from UI","properties":{"categories":{"description":"Array of categories that the selected program belongs to","items":{"description":"","type":"string"},"type":"array"},"level":{"description":"Difficulty level","type":"string"},"location":{"description":"location from which program is selected from","type":"string"},"module":{"description":"module from which program is selected from","type":"string"},"program_slug":{"description":"Designated program slug","type":"string"},"program_title":{"description":"Title of program","type":"string"},"selected_from":{"description":"UI component in which this event fired","type":"string"},"style":{"description":"Class style","type":"string"}},"required":["program_slug","program_title"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Select Program', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentShareContent' track call.
 *
 * @param ContentShareContent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentShareContent(props: ContentShareContent, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Share_Content","$schema":"http://json-schema.org/draft-07/schema#","description":"User opting to share the content they're viewing.","properties":{"content_id":{"description":"The ID of the content.","type":"string"},"content_title":{"description":"The title or the name of the content","type":"string"},"content_type":{"description":"The type of the content.","type":"string"},"location":{"description":"The general location where the content is being shared from.","type":"string"},"module":{"description":"The page where the content is being shared from.","type":"string"}},"required":["content_id","content_type","content_title","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Share Content', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentToggleSaveClass' track call.
 *
 * @param ContentToggleSaveClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentToggleSaveClass(props: ContentToggleSaveClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Toggle_Save_Class","$schema":"http://json-schema.org/draft-07/schema#","description":"User saved or unsaved class","properties":{"categories":{"items":{"type":"string"},"type":"array"},"class_id ":{"type":"integer"},"component":{},"instructor":{"type":"string"},"level":{},"program_slug":{"type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"style":{"description":"Class style","type":"string"},"title":{},"type":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Toggle Save Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentToggleSavePlaylist' track call.
 *
 * @param ContentToggleSavePlaylist props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentToggleSavePlaylist(props: ContentToggleSavePlaylist, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Toggle_Save_Playlist","$schema":"http://json-schema.org/draft-07/schema#","description":"User saving or unsaving the playlist","properties":{"location":{"description":"The general location where the playlist was saved or unsaved.","type":"string"},"module":{"description":"The page where the playlist was saved or unsaved.","type":"string"},"playlist_id":{"description":"The ID of the playlist.","type":"string"},"playlist_name":{"description":"The name of the playlist.","type":"string"},"playlist_user_id":{"description":"The user ID of the owner of the playlist or 'steezy'.","type":"string"}},"required":["playlist_id","playlist_name","playlist_user_id","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Toggle Save Playlist', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ContentToggleSaveProgram' track call.
 *
 * @param ContentToggleSaveProgram props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function contentToggleSaveProgram(props: ContentToggleSaveProgram, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Content_-_Toggle_Save_Program","$schema":"http://json-schema.org/draft-07/schema#","description":"User saved or unsaved program","properties":{"categories":{"description":"List of categories this program belongs to","items":{"type":"string"},"type":"array"},"component":{"description":"UI component in which the program was saved"},"program_slug":{"description":"Slug of the program","type":"string"},"program_title":{"description":"Title of the program","type":"string"},"saved":{"description":"Set to true if user has saved the class","type":"boolean"},"style":{"description":"Style this program belongs to","type":"string"}},"required":["program_slug"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Content - Toggle Save Program', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ElementSelected' track call.
 *
 * @param ElementSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function elementSelected(props: ElementSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ElementSelected","$schema":"http://json-schema.org/draft-07/schema#","description":"When a user has selected a specific element on the UI","properties":{"element_name":{"description":"Element name i.e. ProgramDetailsButton","type":"string"},"element_type":{"description":"Element type i.e. button","type":"string"},"feature":{"description":"The feature the element is related to i.e. ForYou","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"The module the element is encapsulated within","type":"string"},"screen_name":{"description":"Name of the UI screen the user is on i.e. Dashboard","type":"string"}},"required":["element_name","element_type"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ElementSelected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ElementViewed' track call.
 *
 * @param ElementViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function elementViewed(props: ElementViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ElementViewed","$schema":"http://json-schema.org/draft-07/schema#","description":"When a user is rendered a specific view on the UI","properties":{"element_name":{"description":"Element name","type":"string"},"element_type":{"description":"Element type","type":"string"},"feature":{"description":"The feature the view is related to","type":"string"},"module":{"description":"The module the view is related to","type":"string"},"screen_name":{"description":"The screen the element was rendered on","type":"string"}},"required":["element_name","element_type","screen_name"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ElementViewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'Error' track call.
 *
 * @param Error props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function error(props: Error, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Error","$schema":"http://json-schema.org/draft-07/schema#","description":"To track errors that occur in the app","properties":{"location":{"description":"The screen or route the error occurred on","type":"string"},"message":{"description":"The error message","type":"string"},"platform":{"description":"The platform the error occurred on","type":"string"}},"required":["platform","message"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Error', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FUXSelectElement' track call.
 *
 * @param FUXSelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fUXSelectElement(props: FUXSelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FUX_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","description":"fires when user interacts with an interactive FUX item","properties":{"class_card_index":{"description":"place on list that class appears for user (0 based index)","type":"integer"},"class_id":{"description":"id of class","type":"integer"},"class_title":{"description":"title of class","type":"string"},"element_copy":{"description":"copy on the element","type":"string"},"element_name":{"description":"name of element","type":"string"},"element_type":{"description":"type of element","type":"string"},"location":{"description":"location/screen that the element was interacted with","type":"string"},"module":{"description":"ex: \"premium tab\"","type":"string"}},"required":["element_name","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FUX - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FUXViewPlanDetails' track call.
 *
 * @param FUXViewPlanDetails props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fUXViewPlanDetails(props: FUXViewPlanDetails, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FUX_-_View_Plan_Details","$schema":"http://json-schema.org/draft-07/schema#","description":"user views Plan Details screen on Premium tab","properties":{"module":{"description":"ex: \"Premium Tab\"","type":"string"},"plan_type":{"description":"type of plan user is on (ex: \"Lite\")","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FUX - View Plan Details', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FUXViewPremiumTab' track call.
 *
 * @param FUXViewPremiumTab props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fUXViewPremiumTab(props: FUXViewPremiumTab, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FUX_-_View_Premium_Tab","$schema":"http://json-schema.org/draft-07/schema#","description":"fires user sees Premium tab main page","properties":{"module":{"description":"the module this event is fired from","type":"string"}},"required":["module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FUX - View Premium Tab', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FUXViewSubscriptionModal' track call.
 *
 * @param FUXViewSubscriptionModal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fUXViewSubscriptionModal(props: FUXViewSubscriptionModal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FUX_-_View_Subscription_Modal","$schema":"http://json-schema.org/draft-07/schema#","properties":{"categories":{"description":"categories of the locked class the modal is triggered from","items":{"description":"","type":"string"},"type":"array"},"class_id":{"description":"ID of the locked class the modal is triggered from","type":"integer"},"content_type":{"description":"","enum":["class","feature","program"],"type":"string"},"feature_name":{"description":"name of locked feature that displayed the modal","type":"string"},"instructor":{"description":"instructor of the locked class the modal is triggered from","type":"string"},"method":{"description":"Name of element that caused the modal to be displayed","type":"string"},"module":{"description":"Where the modal was triggered from","type":"string"},"program_slug":{"description":"slug of program the modal is triggered from","type":"string"},"program_title":{"description":"title of program the modal is triggered from","type":"string"},"style":{"description":"style of the locked class the modal is triggered from","type":"string"},"title":{"description":"categories of the locked class the modal is triggered from","type":"string"}},"required":["content_type","method","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FUX - View Subscription Modal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FUXViewTryFreeModal' track call.
 *
 * @param FUXViewTryFreeModal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fUXViewTryFreeModal(props: FUXViewTryFreeModal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FUX_-_View_Try_Free_Modal","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_name":{"description":"ex. \"FUX Program Modal\"","type":"string"},"location":{"description":"ex. \"For You\"","type":"string"},"module":{"description":"ex. \"For You\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FUX - View Try Free Modal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FamilyEnterFamilyMode' track call.
 *
 * @param FamilyEnterFamilyMode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function familyEnterFamilyMode(props: FamilyEnterFamilyMode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Family_-_Enter_Family_Mode","$schema":"http://json-schema.org/draft-07/schema#","description":"user successfully enters Family mode after selecting it from the mode selection screen","properties":{"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Family - Enter Family Mode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FamilyEnterStudioMode' track call.
 *
 * @param FamilyEnterStudioMode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function familyEnterStudioMode(props: FamilyEnterStudioMode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Family_-_Enter_Studio_Mode","$schema":"http://json-schema.org/draft-07/schema#","description":"user successfully enters Studio mode after selecting it from the mode selection screeen and entering the correct PIN","properties":{"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Family - Enter Studio Mode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FamilyManageFamilyMode' track call.
 *
 * @param FamilyManageFamilyMode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function familyManageFamilyMode(props: FamilyManageFamilyMode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Family_-_Manage_Family_Mode","$schema":"http://json-schema.org/draft-07/schema#","description":"user does an action on the pin flow page","properties":{"action":{"type":"string"},"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Family - Manage Family Mode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FirstLaunchSelectElement' track call.
 *
 * @param FirstLaunchSelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function firstLaunchSelectElement(props: FirstLaunchSelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"First_Launch_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_copy":{"description":"","type":"string"},"element_name":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('First Launch - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FirstLaunchViewModal' track call.
 *
 * @param FirstLaunchViewModal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function firstLaunchViewModal(props: FirstLaunchViewModal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"First_Launch_-_View_Modal","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_copy":{"description":"copy on the modal","type":"string"},"element_name":{"description":"name of modal","type":"string"},"element_type":{"description":"most likely this is a modal","type":"string"},"location":{"description":"location modal is inflated in","type":"string"},"module":{"description":"module modal is inflated in","type":"string"},"program_slug":{"description":"slug of program if there's a program","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('First Launch - View Modal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HomeSelectContent' track call.
 *
 * @param HomeSelectContent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function homeSelectContent(props: HomeSelectContent, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Home_-_Select_Content","$schema":"http://json-schema.org/draft-07/schema#","description":"fires when user interacts with content in the carousel on home","properties":{"container":{"description":"carousel title in snake_case","enum":["featured_content","recommended_weekly_playlist","trending_classes_level","continue_dancing","dance_workouts","saved_classes","schedule","todays_classes","because_you_liked","warmups_and_stretches","warmups_stretches_and_fundamentals","moves","technique_and_fundamentals","workouts","moves_and_techniques","programs"],"type":"string"},"content_id":{"description":"id of content being clicked on; class_id, program slug, etc.","type":"string"},"content_name":{"description":"title of content","type":"string"},"content_type":{"description":"type of content being accessed; class, program, etc.","enum":["class","program"],"type":"string"},"element_type":{"description":"type of element","type":"string"},"featured":{"description":"is the content a featured type","type":"boolean"},"location":{"description":"location/screen that the element was interacted with","type":"string"},"module":{"description":"ex: \"premium tab\"","type":"string"}},"required":["content_id","content_name","content_type","element_type","container","location","featured"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Home - Select Content', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LibraryFilterContent' track call.
 *
 * @param LibraryFilterContent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function libraryFilterContent(props: LibraryFilterContent, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Library_-_Filter_Content","$schema":"http://json-schema.org/draft-07/schema#","description":"fires when user clicks \"Results\" button after applying filters","properties":{"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"filters_applied":{"description":"array of filters applied","items":{"type":"string"},"type":"array"},"location":{"description":"location content was filtered on","type":"string"},"module":{"description":"ex: \"library_classes\", \"library_programs\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Library - Filter Content', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LibrarySelectContent' track call.
 *
 * @param LibrarySelectContent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function librarySelectContent(props: LibrarySelectContent, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Library_-_Select_Content","$schema":"http://json-schema.org/draft-07/schema#","description":"fires when user selects content from library page","properties":{"account_mode":{"description":"Can studio or family","enum":["studio","family"],"type":"string"},"container":{"description":"title of the section the content is in (must be in snake_case)","enum":["recent_classes","featured_class","classes","categories","programs","instructors"],"type":"string"},"content_id":{"description":"id/slug of content selected","type":"string"},"content_name":{"description":"name of content selected","type":"string"},"content_type":{"description":"type of content selected","enum":["class","program","category","instructor"],"type":"string"},"element_type":{"description":"type of element","type":"string"},"featured":{"description":"indicates if featured content","type":"boolean"},"filters_applied":{"description":"array of filters applied","items":{"type":"string"},"type":"array"},"location":{"description":"location/screen content was selected in","type":"string"},"module":{"description":"ex: \"library_classes\", \"library_programs\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Library - Select Content', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LibrarySelectElement' track call.
 *
 * @param LibrarySelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function librarySelectElement(props: LibrarySelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Library_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","description":"fires when user interacts with an interactive item in Library","properties":{"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"element_name":{"description":"name of element","type":"string"},"element_type":{"description":"type of element","type":"string"},"location":{"description":"location/screen that the element was interacted with","type":"string"},"module":{"description":"ex: \"library_classes\", \"library_programs\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Library - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LibraryViewScreen' track call.
 *
 * @param LibraryViewScreen props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function libraryViewScreen(props: LibraryViewScreen, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Library_-_View_Screen","$schema":"http://json-schema.org/draft-07/schema#","description":"fires when user view screen in library","properties":{"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"location":{"description":"location screen was viewed in","type":"string"},"module":{"description":"ex: \"library_classes\", \"library_programs\"","type":"string"},"screen_name":{"description":"name of screen viewed","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Library - View Screen', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LoadedComponent' track call.
 *
 * @param LoadedComponent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function loadedComponent(props: LoadedComponent, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Loaded_-_Component","$schema":"http://json-schema.org/draft-07/schema#","description":"This is an event to fire when a component has loaded or mounted.","properties":{"component":{"description":"Name of the component","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Loaded - Component', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ManageSubscriptionSelectElement' track call.
 *
 * @param ManageSubscriptionSelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function manageSubscriptionSelectElement(props: ManageSubscriptionSelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Manage_Subscription_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_name":{"type":"string"},"element_type":{"type":"string"},"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Manage Subscription - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ManageSubscriptionViewModal' track call.
 *
 * @param ManageSubscriptionViewModal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function manageSubscriptionViewModal(props: ManageSubscriptionViewModal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Manage_Subscription_-_View_Modal","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_name":{"type":"string"},"element_type":{"type":"string"},"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Manage Subscription - View Modal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ManageSubscriptionViewOffer' track call.
 *
 * @param ManageSubscriptionViewOffer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function manageSubscriptionViewOffer(props: ManageSubscriptionViewOffer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Manage_Subscription_-_View_Offer","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_name":{"type":"string"},"element_type":{"type":"string"},"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Manage Subscription - View Offer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NotificationPermissions' track call.
 *
 * @param NotificationPermissions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function notificationPermissions(props: NotificationPermissions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Notification_Permissions","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_copy":{"description":"","type":"string"},"element_name":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"},"notifications_allowed":{"description":"","type":"boolean"}},"required":["element_name","element_type","location","module","notifications_allowed"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Notification Permissions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingAccountInfoError' track call.
 *
 * @param OnboardingAccountInfoError props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingAccountInfoError(props: OnboardingAccountInfoError, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Account_Info_Error","$schema":"http://json-schema.org/draft-07/schema#","properties":{"Message":{},"code":{},"email":{},"provider":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Account Info Error', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingCompleteAccountInfo' track call.
 *
 * @param OnboardingCompleteAccountInfo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingCompleteAccountInfo(props: OnboardingCompleteAccountInfo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Complete_Account_Info","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding Funnel: user creates an account","properties":{"auth_provider":{},"days_since_first_seen":{},"email":{},"first_name":{},"gclid":{"description":"Google Click Identifier","type":"string"},"last_name":{},"onboarding_ad_enabled":{"description":"Is Ad Tracking Enabled","type":"boolean"},"onboarding_ad_id":{"description":"Advertising Identifier","type":"string"},"path":{},"product_id":{},"products":{"items":{"properties":{"price":{"type":["integer"]},"product_id":{"type":["string"]},"quantity":{"type":["integer"]}},"type":"object"},"type":"array"},"variant":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Complete Account Info', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingHDYHAU' track call.
 *
 * @param OnboardingHDYHAU props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingHDYHAU(props: OnboardingHDYHAU, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_HDYHAU","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects how they heard about STEEZY","properties":{"survey_response":{"description":"List of survey responses that user heard about STEEZY from","items":{"type":"string"},"type":"array"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - HDYHAU', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingPaymentError' track call.
 *
 * @param OnboardingPaymentError props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingPaymentError(props: OnboardingPaymentError, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Payment_Error","$schema":"http://json-schema.org/draft-07/schema#","properties":{"error":{},"payment_method":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Payment Error', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingRegisterScreen' track call.
 *
 * @param OnboardingRegisterScreen props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingRegisterScreen(props: OnboardingRegisterScreen, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Register_Screen","$schema":"http://json-schema.org/draft-07/schema#","properties":{"class_id":{},"path":{},"previous_path":{},"product_id":{},"products":{},"program_id":{},"utm_campaign":{"items":{"type":"string"},"type":"array"},"utm_content":{"items":{"type":"string"},"type":"array"},"utm_id":{"items":{"type":"string"},"type":"array"},"utm_medium":{"items":{"type":"string"},"type":"array"},"utm_source":{"items":{"type":"string"},"type":"array"},"utm_term":{"items":{"type":"string"},"type":"array"},"variant":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Register Screen', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectCategories' track call.
 *
 * @param OnboardingSelectCategories props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectCategories(props: OnboardingSelectCategories, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Categories","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects class category preferences","properties":{"categories":{"description":"web is sending this","items":{"type":"string"},"type":"array"},"categories_array":{"items":{"type":"string"},"type":"array"},"category_array":{"description":"ios and android are sending this","items":{"description":"","type":"string"},"type":"array"},"module":{"type":"string"},"path":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Categories', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDanceCadence' track call.
 *
 * @param OnboardingSelectDanceCadence props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDanceCadence(props: OnboardingSelectDanceCadence, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dance_Cadence","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects when they dance","properties":{"days_of_week":{"items":{"type":"string"},"type":"array"},"module":{"type":"string"},"num_of_days":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dance Cadence', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDanceEnergy' track call.
 *
 * @param OnboardingSelectDanceEnergy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDanceEnergy(props: OnboardingSelectDanceEnergy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dance_Energy","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects their dance energy preference","properties":{"dance_energy":{"type":"string"},"module":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dance Energy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDanceFrequency' track call.
 *
 * @param OnboardingSelectDanceFrequency props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDanceFrequency(props: OnboardingSelectDanceFrequency, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dance_Frequency","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects how often they want to dance","properties":{"dance_frequency":{"type":"string"},"module":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dance Frequency', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDanceGoals' track call.
 *
 * @param OnboardingSelectDanceGoals props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDanceGoals(props: OnboardingSelectDanceGoals, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dance_Goals","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects their dance goals","properties":{"dance_goals":{"items":{"type":"string"},"type":"array"},"module":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dance Goals', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDanceHabit' track call.
 *
 * @param OnboardingSelectDanceHabit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDanceHabit(props: OnboardingSelectDanceHabit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dance_Habit","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects how often they want to dance","properties":{"habit":{"type":"string"},"module":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dance Habit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDanceLocations' track call.
 *
 * @param OnboardingSelectDanceLocations props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDanceLocations(props: OnboardingSelectDanceLocations, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dance_Locations","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects where they prefer to dance","properties":{"dance_locations":{"items":{"type":"string"},"type":"array"},"module":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dance Locations', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDanceStyles' track call.
 *
 * @param OnboardingSelectDanceStyles props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDanceStyles(props: OnboardingSelectDanceStyles, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dance_Styles","$schema":"http://json-schema.org/draft-07/schema#","properties":{"style_array":{"properties":{"breaking":{"type":["boolean"]},"dance-hall":{"type":["boolean"]},"hip-hop":{"type":["boolean"]},"house":{"type":["boolean"]},"krump":{"type":["boolean"]},"popping":{"type":["boolean"]},"urban-dance":{"type":["boolean"]},"whacking":{"type":["boolean"]}},"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dance Styles', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDancer' track call.
 *
 * @param OnboardingSelectDancer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDancer(props: OnboardingSelectDancer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Dancer","$schema":"http://json-schema.org/draft-07/schema#","description":"user chooses an option in the “Select Your Dancer” question during the account creation survey","properties":{"dancer_array":{"type":"array"},"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Dancer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectDuration' track call.
 *
 * @param OnboardingSelectDuration props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectDuration(props: OnboardingSelectDuration, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Duration","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects class length preferences","properties":{"Max":{"type":"integer"},"Min":{"type":"integer"},"max":{"type":"integer"},"min":{"type":"integer"},"module":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Duration', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectFamilyGoal' track call.
 *
 * @param OnboardingSelectFamilyGoal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectFamilyGoal(props: OnboardingSelectFamilyGoal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Family_Goal","$schema":"http://json-schema.org/draft-07/schema#","description":"user selects a choice on the “Family Dance Goal” question during the account creation survey","properties":{"family_goal":{"type":"string"},"location":{"type":"string"},"module":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Family Goal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectLevel' track call.
 *
 * @param OnboardingSelectLevel props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectLevel(props: OnboardingSelectLevel, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Level","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects their self-identified dance skill level","properties":{"dance_level":{"type":"string"},"module":{"type":"string"},"path":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Level', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectReason' track call.
 *
 * @param OnboardingSelectReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectReason(props: OnboardingSelectReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_Reason","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects reason for signing up","properties":{"module":{"type":"string"},"path":{},"reason":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select Reason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingSelectUserAge' track call.
 *
 * @param OnboardingSelectUserAge props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingSelectUserAge(props: OnboardingSelectUserAge, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Select_User_Age","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding survey: user selects their age group","properties":{"module":{"type":"string"},"path":{},"user_age":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Select User Age', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingStartTrial' track call.
 *
 * @param OnboardingStartTrial props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingStartTrial(props: OnboardingStartTrial, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Start_Trial","$schema":"http://json-schema.org/draft-07/schema#","description":"Onboarding Funnel: user starts free trial (checkout)","properties":{"coupon":{},"daypart":{},"days_since_created":{},"discount":{"description":"The value of the coupon code (either the plan_price * % off, or the flat discount amount)."},"discount_amount":{"description":""},"discount_percent":{"description":""},"gclid":{"description":"Google Click Identifier","type":"string"},"onboarding_ad_enabled":{"description":"Is ad tracking enabled","type":"boolean"},"onboarding_ad_id":{"description":"Advertising Identifier","type":"string"},"order_id":{},"path":{},"payment_method":{},"plan":{},"plan_price":{"description":""},"plan_price_after_discount":{"description":""},"platform":{"description":"","type":"string"},"product_id":{},"products":{"items":{"properties":{"price":{"type":["number"]},"product_id":{"type":["string"]},"quantity":{"type":["integer"]}},"type":"object"},"type":"array"},"referred_by":{},"referred_by_username":{},"subscription_id":{},"subscription_renewal_date":{"description":"","format":"date-time","type":"string"},"subscription_start_date":{"description":"","format":"date-time","type":"string"},"trial_length":{},"utm_campaign":{"items":{"type":"string"},"type":"array"},"utm_content":{"items":{"type":"string"},"type":"array"},"utm_id":{"items":{"type":"string"},"type":"array"},"utm_medium":{"items":{"type":"string"},"type":"array"},"utm_source":{"items":{"type":"string"},"type":"array"},"utm_term":{"items":{"type":"string"},"type":"array"},"variant":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Start Trial', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OnboardingVideo' track call.
 *
 * @param OnboardingVideo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function onboardingVideo(props: OnboardingVideo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Onboarding_-_Video","$schema":"http://json-schema.org/draft-07/schema#","properties":{"duration":{},"end_time":{},"slug":{},"start_time":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Onboarding - Video', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OrderCompleted' track call.
 *
 * @param OrderCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function orderCompleted(props: OrderCompleted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Order_Completed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fire this event whenever an order/transaction was successfully completed by the customer.","properties":{"coupon":{"description":"The coupon code applied at checkout","type":"string"},"currency":{"description":"The localized currency of the user","type":"string"},"order_id":{"description":"User's order or transaction ID of the payment provider","type":"string"},"products":{"description":"Products in the order","items":{"description":"","properties":{"name":{"description":"Name of the product being viewed","type":["string"]},"price":{"description":"Price ($) of the product being viewed","type":["number"]},"product_id":{"description":"Database id of the product being viewed","type":["string"]},"quantity":{"description":"Quantity of a product","type":["integer"]},"sku":{"description":"Sku of the product being viewed","type":["string"]}},"required":[],"type":"object"},"type":"array"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Order Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PageViewed' track call.
 *
 * @param PageViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function pageViewed(props: PageViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Page_Viewed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"anonymous":{},"path":{},"previous_path":{},"referrer":{},"search":{},"title":{},"url":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Page Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PlayerLoad' track call.
 *
 * @param PlayerLoad props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function playerLoad(props: PlayerLoad, options?: Options, callback?: Callback): void {

    const schema = {"$id":"PlayerLoad","$schema":"http://json-schema.org/draft-07/schema#","description":"Web tracking initial load events of an HLS.js player. It intentionally tracks just the first instance of each load event to measure initial timings, discarding subsequent occurences.","properties":{"class_id":{"description":"Class ID","type":"integer"},"in_a_party":{"description":"True if user is in a party","type":"boolean"},"initial_hls_quality":{"description":"","type":"string"},"load_event_name":{"description":"What phase of the load event is occurring. Can be one of six values.","enum":[" ready"," request_fragment_start"," request_playlist","mounted","request_fragment_end","request_manifest"],"type":"string"},"manifest_experiment_group":{"description":"","type":"string"},"playback_time.hour":{"description":"Hours in playback time","type":"integer"},"playback_time.minute":{"description":"Minutes in playback time","type":"integer"},"playback_time.second":{"description":"Seconds in playback time","type":"integer"},"time_since_page_load":{"description":"Total time elapsed since page load","type":"number"},"time_since_prev_event":{"description":"Total time since the previous load event","type":"number"},"video_url_suffix":{"description":"","type":"string"}},"required":["class_id","load_event_name"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('PlayerLoad', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PlaylistClick' track call.
 *
 * @param PlaylistClick props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function playlistClick(props: PlaylistClick, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Playlist_-_Click","$schema":"http://json-schema.org/draft-07/schema#","properties":{"event_time":{"type":"string"},"playlistId":{"type":"string"},"playlist_id":{"type":"string"},"scheduleIndex":{"type":"string"},"schedule_id":{"type":"string"},"schedule_index":{"type":"integer"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Playlist - Click', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PlaylistsEditPlaylist' track call.
 *
 * @param PlaylistsEditPlaylist props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function playlistsEditPlaylist(props: PlaylistsEditPlaylist, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Playlists_-_Edit_Playlist","$schema":"http://json-schema.org/draft-07/schema#","description":"User successfully creates, edits, or deletes a playlist. Actions can also include adding, removing, or re-ordering classes in the playlist.","properties":{"action":{"description":"The playlist action the user is taking.","type":"string"},"class_id":{"description":"The ID of the class that was added or removed from playlist.","type":"string"},"location":{"description":"The general location where the playlist action occurred.","type":"string"},"module":{"description":"The page where the playlist action occurred.","type":"string"},"playlist_id":{"description":"The ID of the playlist.","type":"string"},"playlist_name":{"description":"The name of the playlist.","type":"string"},"privacy":{"description":"The privacy setting of the playlist.","type":"string"}},"required":["action","playlist_id","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Playlists - Edit Playlist', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PlaylistsSelectElement' track call.
 *
 * @param PlaylistsSelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function playlistsSelectElement(props: PlaylistsSelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Playlists_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects an element on the Playlists page.","properties":{"element_name":{"description":"Name of the element.","type":"string"},"element_type":{"description":"Name of the element.","type":"string"},"location":{"description":"The general location where the element was selected.","type":"string"},"module":{"description":"The page where the element was selected.","type":"string"}},"required":["element_name","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Playlists - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PlaylistsViewScreen' track call.
 *
 * @param PlaylistsViewScreen props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function playlistsViewScreen(props: PlaylistsViewScreen, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Playlists_-_View_Screen","$schema":"http://json-schema.org/draft-07/schema#","description":"User viewing one of the Playlist screens.","properties":{"location":{"description":"The general location where the element was viewed.","type":"string"},"module":{"description":"The page where the element was viewed.","type":"string"},"screen_name":{"description":"Name of the screen being viewed.","type":"string"}},"required":["screen_name","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Playlists - View Screen', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfileSelectElement' track call.
 *
 * @param ProfileSelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profileSelectElement(props: ProfileSelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_-_Select_Element","$schema":"http://json-schema.org/draft-07/schema#","description":"user clicks on the Steezy Family item from the Account section of Profile, bringing them to the Steezy Family screen (marketing OR manage based on whether pin is enabled already)","properties":{"element_name":{"type":"string"},"element_type":{"type":"string"},"location":{"type":"string"},"module":{"type":"string"},"pin_enabled":{"type":"boolean"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile - Select Element', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralOpenCTA' track call.
 *
 * @param ReferralOpenCTA props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralOpenCTA(props: ReferralOpenCTA, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Open_CTA","$schema":"http://json-schema.org/draft-07/schema#","description":"Called when the user clicks the CTA to open the Referrals Screen","properties":{"account_status":{"description":"","type":"string"},"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["account_status","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Open CTA', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralSelectAvailableCredits' track call.
 *
 * @param ReferralSelectAvailableCredits props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralSelectAvailableCredits(props: ReferralSelectAvailableCredits, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Select_Available_Credits","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on available credits row","properties":{"credits_available":{"description":"Number of credits available in whole dollars","type":"integer"},"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Select Available Credits', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralSelectClassesToUnlock' track call.
 *
 * @param ReferralSelectClassesToUnlock props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralSelectClassesToUnlock(props: ReferralSelectClassesToUnlock, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Select_Classes_to_Unlock","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on classes to unlock row","properties":{"classes_available":{"description":"","type":"integer"},"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Select Classes to Unlock', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralSelectInviteHistory' track call.
 *
 * @param ReferralSelectInviteHistory props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralSelectInviteHistory(props: ReferralSelectInviteHistory, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Select_Invite_History","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on invite history","properties":{"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Select Invite History', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralSelectShareButton' track call.
 *
 * @param ReferralSelectShareButton props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralSelectShareButton(props: ReferralSelectShareButton, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Select_Share_Button","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on share invite button","properties":{"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Select Share Button', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralSelectTermsAndConditions' track call.
 *
 * @param ReferralSelectTermsAndConditions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralSelectTermsAndConditions(props: ReferralSelectTermsAndConditions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Select_Terms_and_Conditions","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on terms and conditions","properties":{"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Select Terms and Conditions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralSelectViewClassesButton' track call.
 *
 * @param ReferralSelectViewClassesButton props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralSelectViewClassesButton(props: ReferralSelectViewClassesButton, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Select_View_Classes_Button","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on view classes button from modal","properties":{"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Select View Classes Button', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralSelectViewUnlockedClasses' track call.
 *
 * @param ReferralSelectViewUnlockedClasses props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralSelectViewUnlockedClasses(props: ReferralSelectViewUnlockedClasses, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Select_View_Unlocked_Classes","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked on unlocked classes row","properties":{"classes_unlocked":{"description":"","type":"integer"},"element_copy":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Select View Unlocked Classes', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralUnlockClass' track call.
 *
 * @param ReferralUnlockClass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralUnlockClass(props: ReferralUnlockClass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_Unlock_Class","$schema":"http://json-schema.org/draft-07/schema#","properties":{"class_id":{"description":"","type":"string"},"element_copy":{"description":"","type":["string","null"]},"element_type":{"description":"","type":["string","null"]},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - Unlock Class', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ReferralViewModal' track call.
 *
 * @param ReferralViewModal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function referralViewModal(props: ReferralViewModal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Referral_-_View_Modal","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_copy":{"description":"","type":"string"},"element_name":{"description":"","type":"string"},"element_type":{"description":"","type":"string"},"location":{"description":"","type":"string"},"module":{"description":"","type":"string"}},"required":["element_copy","element_name","element_type","location","module"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Referral - View Modal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ScreenViewed' track call.
 *
 * @param ScreenViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function screenViewed(props: ScreenViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Screen_Viewed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"Class Name":{},"Screen":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Screen Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SearchSearchClasses' track call.
 *
 * @param SearchSearchClasses props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function searchSearchClasses(props: SearchSearchClasses, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Search_-_Search_Classes","$schema":"http://json-schema.org/draft-07/schema#","properties":{"hits":{},"query":{},"search":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Search - Search Classes', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SearchSelectContent' track call.
 *
 * @param SearchSelectContent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function searchSelectContent(props: SearchSelectContent, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Search_-_Select_Content","$schema":"http://json-schema.org/draft-07/schema#","description":"fires when user selects content from Search","properties":{"account_mode":{"description":"Can be studio or family","enum":["studio","family"],"type":"string"},"container":{"description":"title of the section the content is in (must be in snake_case)","type":"string"},"content_id":{"description":"id of selected content","type":"string"},"content_name":{"description":"name of selected content","type":"string"},"content_type":{"description":"type of selected content","type":"string"},"element_type":{"description":"content type","type":"string"},"location":{"description":"location content was selected from","type":"string"},"module":{"description":"ex: \"search_all_results\", \"search_classes\"","type":"string"},"search_text":{"description":"query text typed into search box","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Search - Select Content', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SelectElement' track call.
 *
 * @param SelectElement props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function selectElement(props: SelectElement, options?: Options, callback?: Callback): void {

    const schema = {"$id":"SelectElement","$schema":"http://json-schema.org/draft-07/schema#","properties":{"element_name":{"type":"string"},"event_time":{"type":"string"},"location":{"type":"string"},"lookback_delta":{"type":"integer"},"module":{"type":"string"},"platform":{"type":"string"},"taken_list_date":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('SelectElement', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SubscribeAddSubscription' track call.
 *
 * @param SubscribeAddSubscription props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function subscribeAddSubscription(props: SubscribeAddSubscription, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Subscribe_-_Add_Subscription","$schema":"http://json-schema.org/draft-07/schema#","description":"User purchases a new subscription without trial (user completes Checkout, not eligible for Trial)","properties":{"coupon":{},"daypart":{},"days_since_created":{},"discount":{"description":"The value of the coupon code (either the plan_price * % off, or the flat discount amount)."},"discount_amount":{"description":""},"discount_percent":{"description":""},"order_id":{},"path":{},"payment_method":{},"plan":{},"plan_price":{"description":""},"plan_price_after_discount":{"description":""},"platform":{"description":"","type":"string"},"product_id":{},"products":{"items":{"properties":{"price":{"type":["number"]},"product_id":{"type":["string"]},"quantity":{"type":["integer"]}},"type":"object"},"type":"array"},"subscription_id":{},"subscription_provider":{"description":"The subscription's provider platform (e.g. Chargebee, RevenueCat, etc.)","type":"string"},"subscription_renewal_date":{"description":"","format":"date-time","type":"string"},"subscription_start_date":{"description":"","format":"date-time","type":"string"},"trial_length":{},"utm_campaign":{},"utm_content":{},"utm_medium":{},"utm_source":{},"variant":{"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Subscribe - Add Subscription', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SubscribeRestoreSubscription' track call.
 *
 * @param SubscribeRestoreSubscription props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function subscribeRestoreSubscription(props: SubscribeRestoreSubscription, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Subscribe_-_Restore_Subscription","$schema":"http://json-schema.org/draft-07/schema#","properties":{"active_entitlements":{"properties":{"subscription":{"type":["string"]}},"type":"object"},"active_subscriptions":{"items":{"type":"string"},"type":"array"},"all_purchased_productid":{"items":{"type":"string"},"type":"array"},"first_seen":{},"latest_expiration_date":{},"original_app_userid":{},"purchaserInfo":{},"request_date":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Subscribe - Restore Subscription', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SubscribeSelectPaymentMethod' track call.
 *
 * @param SubscribeSelectPaymentMethod props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function subscribeSelectPaymentMethod(props: SubscribeSelectPaymentMethod, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Subscribe_-_Select_Payment_Method","$schema":"http://json-schema.org/draft-07/schema#","properties":{"path":{},"payment_method":{},"plan":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Subscribe - Select Payment Method', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SubscribeSelectPlan' track call.
 *
 * @param SubscribeSelectPlan props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function subscribeSelectPlan(props: SubscribeSelectPlan, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Subscribe_-_Select_Plan","$schema":"http://json-schema.org/draft-07/schema#","properties":{"module":{"description":"where the modal was inflated from","type":"string"},"path":{},"plan":{"description":"","type":"string"},"variant":{}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Subscribe - Select Plan', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UsePlaybackControl' track call.
 *
 * @param UsePlaybackControl props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function usePlaybackControl(props: UsePlaybackControl, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UsePlaybackControl","$schema":"http://json-schema.org/draft-07/schema#","properties":{"adjusted_to":{},"adjustment_type":{"type":"string"},"cast_control":{"type":"string"},"classId":{"type":"integer"},"class_id":{"type":"integer"},"control_used":{"type":"string"},"create_loop":{"items":{"type":"integer"},"type":"array"},"cuepoint_name":{"type":"string"},"end_loop":{"type":"boolean"},"in_a_party":{"type":"boolean"},"mirrored":{"type":"string"},"party_session_id":{"type":"string"},"playback_time":{"type":"string"},"section_name":{"type":"string"},"section_selected":{"type":"string"},"skip_to":{"type":"string"},"toggle_camera":{"type":"boolean"},"toggle_fullscreen":{"type":"boolean"},"toggled_to":{"type":"string"},"volume_set_to":{"type":"number"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UsePlaybackControl', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UseVideoPartyControl' track call.
 *
 * @param UseVideoPartyControl props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function useVideoPartyControl(props: UseVideoPartyControl, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UseVideoPartyControl","$schema":"http://json-schema.org/draft-07/schema#","properties":{"mute":{"type":"boolean"},"party_session_id":{"type":"string"},"video":{"type":"boolean"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UseVideoPartyControl', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}

const clientAPI = {
    /**
     * Updates the run-time configuration of this Typewriter client.
     *
     * @param {TypewriterOptions} options - the options to upsert
     *
     * @typedef {Object} TypewriterOptions
     * @property {AnalyticsJS} [analytics] - Underlying analytics instance where analytics
     * 		calls are forwarded on to. Defaults to window.analytics.
     * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
     * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
     * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
     * 		will be logged to stderr.
     */
    setTypewriterOptions,

    /**
     * Fires a 'ApplicationInstalled' track call.
     *
     * @param ApplicationInstalled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    applicationInstalled,
    /**
     * Fires a 'ApplicationOpened' track call.
     *
     * @param ApplicationOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    applicationOpened,
    /**
     * Fires a 'ApplicationUpdated' track call.
     *
     * @param ApplicationUpdated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    applicationUpdated,
    /**
     * Fires a 'CancelClick' track call.
     *
     * @param CancelClick props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cancelClick,
    /**
     * Fires a 'CancelRating' track call.
     *
     * @param CancelRating props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cancelRating,
    /**
     * Fires a 'CancelReason' track call.
     *
     * @param CancelReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cancelReason,
    /**
     * Fires a 'CastClass' track call.
     *
     * @param CastClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    castClass,
    /**
     * Fires a 'CheckoutSelectElement' track call.
     *
     * @param CheckoutSelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    checkoutSelectElement,
    /**
     * Fires a 'CheckoutSelectReferralsLearnMore' track call.
     *
     * @param CheckoutSelectReferralsLearnMore props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    checkoutSelectReferralsLearnMore,
    /**
     * Fires a 'CheckoutViewCheckout' track call.
     *
     * @param CheckoutViewCheckout props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    checkoutViewCheckout,
    /**
     * Fires a 'CheckoutViewModal' track call.
     *
     * @param CheckoutViewModal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    checkoutViewModal,
    /**
     * Fires a 'ClassCompleteClass' track call.
     *
     * @param ClassCompleteClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classCompleteClass,
    /**
     * Fires a 'ClassContinueClass' track call.
     *
     * @param ClassContinueClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classContinueClass,
    /**
     * Fires a 'ClassDownloadClass' track call.
     *
     * @param ClassDownloadClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classDownloadClass,
    /**
     * Fires a 'ClassDownloadComplete' track call.
     *
     * @param ClassDownloadComplete props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classDownloadComplete,
    /**
     * Fires a 'ClassEndClass' track call.
     *
     * @param ClassEndClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classEndClass,
    /**
     * Fires a 'ClassOpenClass' track call.
     *
     * @param ClassOpenClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classOpenClass,
    /**
     * Fires a 'ClassPause' track call.
     *
     * @param ClassPause props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classPause,
    /**
     * Fires a 'ClassPauseClass' track call.
     *
     * @param ClassPauseClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classPauseClass,
    /**
     * Fires a 'ClassPlay' track call.
     *
     * @param ClassPlay props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classPlay,
    /**
     * Fires a 'ClassPlayerBuffering' track call.
     *
     * @param ClassPlayerBuffering props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classPlayerBuffering,
    /**
     * Fires a 'ClassReviewClass' track call.
     *
     * @param ClassReviewClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classReviewClass,
    /**
     * Fires a 'ClassReviewSection' track call.
     *
     * @param ClassReviewSection props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classReviewSection,
    /**
     * Fires a 'ClassSkip' track call.
     *
     * @param ClassSkip props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classSkip,
    /**
     * Fires a 'ClassSkipSection' track call.
     *
     * @param ClassSkipSection props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classSkipSection,
    /**
     * Fires a 'ClassSpeed' track call.
     *
     * @param ClassSpeed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classSpeed,
    /**
     * Fires a 'ClassStartClass' track call.
     *
     * @param ClassStartClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classStartClass,
    /**
     * Fires a 'ClassSwitchView' track call.
     *
     * @param ClassSwitchView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classSwitchView,
    /**
     * Fires a 'ClassTakingClass' track call.
     *
     * @param ClassTakingClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classTakingClass,
    /**
     * Fires a 'ClassToggleMirror' track call.
     *
     * @param ClassToggleMirror props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    classToggleMirror,
    /**
     * Fires a 'ClickExternalLink' track call.
     *
     * @param ClickExternalLink props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    clickExternalLink,
    /**
     * Fires a 'ClickLink' track call.
     *
     * @param ClickLink props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    clickLink,
    /**
     * Fires a 'ClickShare' track call.
     *
     * @param ClickShare props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    clickShare,
    /**
     * Fires a 'CommunityContentFlag' track call.
     *
     * @param CommunityContentFlag props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    communityContentFlag,
    /**
     * Fires a 'CommunitySelectElement' track call.
     *
     * @param CommunitySelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    communitySelectElement,
    /**
     * Fires a 'CommunitySubmitComment' track call.
     *
     * @param CommunitySubmitComment props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    communitySubmitComment,
    /**
     * Fires a 'CommunityVideoActivity' track call.
     *
     * @param CommunityVideoActivity props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    communityVideoActivity,
    /**
     * Fires a 'CommunityViewCommunityGuidelines' track call.
     *
     * @param CommunityViewCommunityGuidelines props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    communityViewCommunityGuidelines,
    /**
     * Fires a 'ContentFilterClasses' track call.
     *
     * @param ContentFilterClasses props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentFilterClasses,
    /**
     * Fires a 'ContentFilterPrograms' track call.
     *
     * @param ContentFilterPrograms props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentFilterPrograms,
    /**
     * Fires a 'ContentPreviewClass' track call.
     *
     * @param ContentPreviewClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentPreviewClass,
    /**
     * Fires a 'ContentPreviewProgram' track call.
     *
     * @param ContentPreviewProgram props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentPreviewProgram,
    /**
     * Fires a 'ContentSelectCategory' track call.
     *
     * @param ContentSelectCategory props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentSelectCategory,
    /**
     * Fires a 'ContentSelectClass' track call.
     *
     * @param ContentSelectClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentSelectClass,
    /**
     * Fires a 'ContentSelectElement' track call.
     *
     * @param ContentSelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentSelectElement,
    /**
     * Fires a 'ContentSelectPlaylist' track call.
     *
     * @param ContentSelectPlaylist props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentSelectPlaylist,
    /**
     * Fires a 'ContentSelectProgram' track call.
     *
     * @param ContentSelectProgram props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentSelectProgram,
    /**
     * Fires a 'ContentShareContent' track call.
     *
     * @param ContentShareContent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentShareContent,
    /**
     * Fires a 'ContentToggleSaveClass' track call.
     *
     * @param ContentToggleSaveClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentToggleSaveClass,
    /**
     * Fires a 'ContentToggleSavePlaylist' track call.
     *
     * @param ContentToggleSavePlaylist props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentToggleSavePlaylist,
    /**
     * Fires a 'ContentToggleSaveProgram' track call.
     *
     * @param ContentToggleSaveProgram props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contentToggleSaveProgram,
    /**
     * Fires a 'ElementSelected' track call.
     *
     * @param ElementSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    elementSelected,
    /**
     * Fires a 'ElementViewed' track call.
     *
     * @param ElementViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    elementViewed,
    /**
     * Fires a 'Error' track call.
     *
     * @param Error props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    error,
    /**
     * Fires a 'FUXSelectElement' track call.
     *
     * @param FUXSelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fUXSelectElement,
    /**
     * Fires a 'FUXViewPlanDetails' track call.
     *
     * @param FUXViewPlanDetails props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fUXViewPlanDetails,
    /**
     * Fires a 'FUXViewPremiumTab' track call.
     *
     * @param FUXViewPremiumTab props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fUXViewPremiumTab,
    /**
     * Fires a 'FUXViewSubscriptionModal' track call.
     *
     * @param FUXViewSubscriptionModal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fUXViewSubscriptionModal,
    /**
     * Fires a 'FUXViewTryFreeModal' track call.
     *
     * @param FUXViewTryFreeModal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fUXViewTryFreeModal,
    /**
     * Fires a 'FamilyEnterFamilyMode' track call.
     *
     * @param FamilyEnterFamilyMode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    familyEnterFamilyMode,
    /**
     * Fires a 'FamilyEnterStudioMode' track call.
     *
     * @param FamilyEnterStudioMode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    familyEnterStudioMode,
    /**
     * Fires a 'FamilyManageFamilyMode' track call.
     *
     * @param FamilyManageFamilyMode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    familyManageFamilyMode,
    /**
     * Fires a 'FirstLaunchSelectElement' track call.
     *
     * @param FirstLaunchSelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    firstLaunchSelectElement,
    /**
     * Fires a 'FirstLaunchViewModal' track call.
     *
     * @param FirstLaunchViewModal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    firstLaunchViewModal,
    /**
     * Fires a 'HomeSelectContent' track call.
     *
     * @param HomeSelectContent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    homeSelectContent,
    /**
     * Fires a 'LibraryFilterContent' track call.
     *
     * @param LibraryFilterContent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    libraryFilterContent,
    /**
     * Fires a 'LibrarySelectContent' track call.
     *
     * @param LibrarySelectContent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    librarySelectContent,
    /**
     * Fires a 'LibrarySelectElement' track call.
     *
     * @param LibrarySelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    librarySelectElement,
    /**
     * Fires a 'LibraryViewScreen' track call.
     *
     * @param LibraryViewScreen props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    libraryViewScreen,
    /**
     * Fires a 'LoadedComponent' track call.
     *
     * @param LoadedComponent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    loadedComponent,
    /**
     * Fires a 'ManageSubscriptionSelectElement' track call.
     *
     * @param ManageSubscriptionSelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    manageSubscriptionSelectElement,
    /**
     * Fires a 'ManageSubscriptionViewModal' track call.
     *
     * @param ManageSubscriptionViewModal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    manageSubscriptionViewModal,
    /**
     * Fires a 'ManageSubscriptionViewOffer' track call.
     *
     * @param ManageSubscriptionViewOffer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    manageSubscriptionViewOffer,
    /**
     * Fires a 'NotificationPermissions' track call.
     *
     * @param NotificationPermissions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    notificationPermissions,
    /**
     * Fires a 'OnboardingAccountInfoError' track call.
     *
     * @param OnboardingAccountInfoError props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingAccountInfoError,
    /**
     * Fires a 'OnboardingCompleteAccountInfo' track call.
     *
     * @param OnboardingCompleteAccountInfo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingCompleteAccountInfo,
    /**
     * Fires a 'OnboardingHDYHAU' track call.
     *
     * @param OnboardingHDYHAU props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingHDYHAU,
    /**
     * Fires a 'OnboardingPaymentError' track call.
     *
     * @param OnboardingPaymentError props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingPaymentError,
    /**
     * Fires a 'OnboardingRegisterScreen' track call.
     *
     * @param OnboardingRegisterScreen props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingRegisterScreen,
    /**
     * Fires a 'OnboardingSelectCategories' track call.
     *
     * @param OnboardingSelectCategories props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectCategories,
    /**
     * Fires a 'OnboardingSelectDanceCadence' track call.
     *
     * @param OnboardingSelectDanceCadence props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDanceCadence,
    /**
     * Fires a 'OnboardingSelectDanceEnergy' track call.
     *
     * @param OnboardingSelectDanceEnergy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDanceEnergy,
    /**
     * Fires a 'OnboardingSelectDanceFrequency' track call.
     *
     * @param OnboardingSelectDanceFrequency props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDanceFrequency,
    /**
     * Fires a 'OnboardingSelectDanceGoals' track call.
     *
     * @param OnboardingSelectDanceGoals props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDanceGoals,
    /**
     * Fires a 'OnboardingSelectDanceHabit' track call.
     *
     * @param OnboardingSelectDanceHabit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDanceHabit,
    /**
     * Fires a 'OnboardingSelectDanceLocations' track call.
     *
     * @param OnboardingSelectDanceLocations props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDanceLocations,
    /**
     * Fires a 'OnboardingSelectDanceStyles' track call.
     *
     * @param OnboardingSelectDanceStyles props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDanceStyles,
    /**
     * Fires a 'OnboardingSelectDancer' track call.
     *
     * @param OnboardingSelectDancer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDancer,
    /**
     * Fires a 'OnboardingSelectDuration' track call.
     *
     * @param OnboardingSelectDuration props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectDuration,
    /**
     * Fires a 'OnboardingSelectFamilyGoal' track call.
     *
     * @param OnboardingSelectFamilyGoal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectFamilyGoal,
    /**
     * Fires a 'OnboardingSelectLevel' track call.
     *
     * @param OnboardingSelectLevel props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectLevel,
    /**
     * Fires a 'OnboardingSelectReason' track call.
     *
     * @param OnboardingSelectReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectReason,
    /**
     * Fires a 'OnboardingSelectUserAge' track call.
     *
     * @param OnboardingSelectUserAge props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingSelectUserAge,
    /**
     * Fires a 'OnboardingStartTrial' track call.
     *
     * @param OnboardingStartTrial props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingStartTrial,
    /**
     * Fires a 'OnboardingVideo' track call.
     *
     * @param OnboardingVideo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    onboardingVideo,
    /**
     * Fires a 'OrderCompleted' track call.
     *
     * @param OrderCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    orderCompleted,
    /**
     * Fires a 'PageViewed' track call.
     *
     * @param PageViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pageViewed,
    /**
     * Fires a 'PlayerLoad' track call.
     *
     * @param PlayerLoad props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    playerLoad,
    /**
     * Fires a 'PlaylistClick' track call.
     *
     * @param PlaylistClick props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    playlistClick,
    /**
     * Fires a 'PlaylistsEditPlaylist' track call.
     *
     * @param PlaylistsEditPlaylist props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    playlistsEditPlaylist,
    /**
     * Fires a 'PlaylistsSelectElement' track call.
     *
     * @param PlaylistsSelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    playlistsSelectElement,
    /**
     * Fires a 'PlaylistsViewScreen' track call.
     *
     * @param PlaylistsViewScreen props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    playlistsViewScreen,
    /**
     * Fires a 'ProfileSelectElement' track call.
     *
     * @param ProfileSelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profileSelectElement,
    /**
     * Fires a 'ReferralOpenCTA' track call.
     *
     * @param ReferralOpenCTA props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralOpenCTA,
    /**
     * Fires a 'ReferralSelectAvailableCredits' track call.
     *
     * @param ReferralSelectAvailableCredits props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralSelectAvailableCredits,
    /**
     * Fires a 'ReferralSelectClassesToUnlock' track call.
     *
     * @param ReferralSelectClassesToUnlock props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralSelectClassesToUnlock,
    /**
     * Fires a 'ReferralSelectInviteHistory' track call.
     *
     * @param ReferralSelectInviteHistory props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralSelectInviteHistory,
    /**
     * Fires a 'ReferralSelectShareButton' track call.
     *
     * @param ReferralSelectShareButton props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralSelectShareButton,
    /**
     * Fires a 'ReferralSelectTermsAndConditions' track call.
     *
     * @param ReferralSelectTermsAndConditions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralSelectTermsAndConditions,
    /**
     * Fires a 'ReferralSelectViewClassesButton' track call.
     *
     * @param ReferralSelectViewClassesButton props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralSelectViewClassesButton,
    /**
     * Fires a 'ReferralSelectViewUnlockedClasses' track call.
     *
     * @param ReferralSelectViewUnlockedClasses props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralSelectViewUnlockedClasses,
    /**
     * Fires a 'ReferralUnlockClass' track call.
     *
     * @param ReferralUnlockClass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralUnlockClass,
    /**
     * Fires a 'ReferralViewModal' track call.
     *
     * @param ReferralViewModal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    referralViewModal,
    /**
     * Fires a 'ScreenViewed' track call.
     *
     * @param ScreenViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    screenViewed,
    /**
     * Fires a 'SearchSearchClasses' track call.
     *
     * @param SearchSearchClasses props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    searchSearchClasses,
    /**
     * Fires a 'SearchSelectContent' track call.
     *
     * @param SearchSelectContent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    searchSelectContent,
    /**
     * Fires a 'SelectElement' track call.
     *
     * @param SelectElement props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    selectElement,
    /**
     * Fires a 'SubscribeAddSubscription' track call.
     *
     * @param SubscribeAddSubscription props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    subscribeAddSubscription,
    /**
     * Fires a 'SubscribeRestoreSubscription' track call.
     *
     * @param SubscribeRestoreSubscription props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    subscribeRestoreSubscription,
    /**
     * Fires a 'SubscribeSelectPaymentMethod' track call.
     *
     * @param SubscribeSelectPaymentMethod props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    subscribeSelectPaymentMethod,
    /**
     * Fires a 'SubscribeSelectPlan' track call.
     *
     * @param SubscribeSelectPlan props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    subscribeSelectPlan,
    /**
     * Fires a 'UsePlaybackControl' track call.
     *
     * @param UsePlaybackControl props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    usePlaybackControl,
    /**
     * Fires a 'UseVideoPartyControl' track call.
     *
     * @param UseVideoPartyControl props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    useVideoPartyControl,
};

export default new Proxy<typeof clientAPI>(clientAPI, {
    get(target, method) {
        if (typeof method === 'string' && target.hasOwnProperty(method)) {
            return target[method as keyof typeof clientAPI];
        }

        return () => {
            console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
         a) Re-generate your typewriter client: \`npx typewriter\`
         b) Add it to your Tracking Plan: https://app.segment.com/segment-oscb/protocols/tracking-plans/rs_1zTHJU9fd5mt7cndWnd4PgJbMCE`);
            const a = analytics();
            if (a) {
                a.track(
                    'Unknown Analytics Call Fired',
                    {
                        method,
                    },
                    withTypewriterContext(),
                );
            }
        };
    },
});

